import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: any;
};

export type ActionsAccessPayload = {
  __typename?: 'ActionsAccessPayload';
  reason?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Boolean']>;
};

export type Asset = Node & {
  __typename?: 'Asset';
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Asset`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  mimetype?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Poll`. */
  pollsByImageId: PollsConnection;
  settings?: Maybe<Scalars['String']>;
  state: AssetsStateEnum;
  updatedAt: Scalars['Datetime'];
  url?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `User`. */
  usersByPollImageIdAndCreatedById: AssetUsersByPollImageIdAndCreatedByIdManyToManyConnection;
  uuid?: Maybe<Scalars['String']>;
};


export type AssetPollsByImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};


export type AssetUsersByPollImageIdAndCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A condition to be used against `Asset` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AssetCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `filename` field. */
  filename?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `mimetype` field. */
  mimetype?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `settings` field. */
  settings?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<AssetsStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `uuid` field. */
  uuid?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Asset` object types. All fields are combined with a logical ‘and.’ */
export type AssetFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AssetFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `filename` field. */
  filename?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `mimetype` field. */
  mimetype?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AssetFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AssetFilter>>;
  /** Filter by the object’s `settings` field. */
  settings?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<AssetsStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `uuid` field. */
  uuid?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Asset` */
export type AssetInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mimetype?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInverseInput>;
  settings?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssetsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7Input>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type AssetNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `asset` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type AssetNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `asset` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type AssetOnAssetForFk3B4041F72C74134Fd253C373Ce7NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `asset` to look up the row to update. */
export type AssetOnAssetForFk3B4041F72C74134Fd253C373Ce7UsingPkBbd9B67466Ce36Ece4B2F1E4Fd1Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `asset` being updated. */
  patch: UpdateAssetOnAssetForFk3B4041F72C74134Fd253C373Ce7Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type AssetOnPollForFk92Fe09641A13814B79Fec585F8ENodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `poll` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: PollPatch;
};

/** The fields on `asset` to look up the row to update. */
export type AssetOnPollForFk92Fe09641A13814B79Fec585F8EUsingPkBbd9B67466Ce36Ece4B2F1E4Fd1Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `asset` being updated. */
  patch: UpdateAssetOnPollForFk92Fe09641A13814B79Fec585F8EPatch;
};

/** Represents an update to a `Asset`. Fields that are set will be updated. */
export type AssetPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mimetype?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInverseInput>;
  settings?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssetsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7Input>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** The fields on `asset` to look up the row to connect. */
export type AssetPkBbd9B67466Ce36Ece4B2F1E4Fd1Connect = {
  id: Scalars['Int'];
};

/** The fields on `asset` to look up the row to delete. */
export type AssetPkBbd9B67466Ce36Ece4B2F1E4Fd1Delete = {
  id: Scalars['Int'];
};

/** A connection to a list of `User` values, with data from `Poll`. */
export type AssetUsersByPollImageIdAndCreatedByIdManyToManyConnection = {
  __typename?: 'AssetUsersByPollImageIdAndCreatedByIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Poll`, and the cursor to aid in pagination. */
  edges: Array<AssetUsersByPollImageIdAndCreatedByIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Poll`. */
export type AssetUsersByPollImageIdAndCreatedByIdManyToManyEdge = {
  __typename?: 'AssetUsersByPollImageIdAndCreatedByIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
  /** Reads and enables pagination through a set of `Poll`. */
  pollsByCreatedById: PollsConnection;
};


/** A `User` edge in the connection, with data from `Poll`. */
export type AssetUsersByPollImageIdAndCreatedByIdManyToManyEdgePollsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};

/** A connection to a list of `Asset` values. */
export type AssetsConnection = {
  __typename?: 'AssetsConnection';
  /** A list of edges which contains the `Asset` and cursor to aid in pagination. */
  edges: Array<AssetsEdge>;
  /** A list of `Asset` objects. */
  nodes: Array<Maybe<Asset>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Asset` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Asset` edge in the connection. */
export type AssetsEdge = {
  __typename?: 'AssetsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Asset` at the end of the edge. */
  node?: Maybe<Asset>;
};

/** Methods to use when ordering `Asset`. */
export enum AssetsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  FilenameAsc = 'FILENAME_ASC',
  FilenameDesc = 'FILENAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  MimetypeAsc = 'MIMETYPE_ASC',
  MimetypeDesc = 'MIMETYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SettingsAsc = 'SETTINGS_ASC',
  SettingsDesc = 'SETTINGS_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UrlAsc = 'URL_ASC',
  UrlDesc = 'URL_DESC',
  UuidAsc = 'UUID_ASC',
  UuidDesc = 'UUID_DESC'
}

export enum AssetsStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against AssetsStateEnum fields. All fields are combined with a logical ‘and.’ */
export type AssetsStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AssetsStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AssetsStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AssetsStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AssetsStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AssetsStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AssetsStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AssetsStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AssetsStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AssetsStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AssetsStateEnum>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** All input for the create `Asset` mutation. */
export type CreateAssetInput = {
  /** The `Asset` to be created by this mutation. */
  asset: AssetInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Asset` mutation. */
export type CreateAssetPayload = {
  __typename?: 'CreateAssetPayload';
  /** The `Asset` that was created by this mutation. */
  asset?: Maybe<Asset>;
  /** An edge for our `Asset`. May be used by Relay 1. */
  assetEdge?: Maybe<AssetsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Asset`. */
  createdBy?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Asset` mutation. */
export type CreateAssetPayloadAssetEdgeArgs = {
  orderBy?: InputMaybe<Array<AssetsOrderBy>>;
};

/** All input for the create `Domain` mutation. */
export type CreateDomainInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Domain` to be created by this mutation. */
  domain: DomainInput;
};

/** The output of our create `Domain` mutation. */
export type CreateDomainPayload = {
  __typename?: 'CreateDomainPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Domain`. */
  createdBy?: Maybe<User>;
  /** The `Domain` that was created by this mutation. */
  domain?: Maybe<Domain>;
  /** An edge for our `Domain`. May be used by Relay 1. */
  domainEdge?: Maybe<DomainsEdge>;
  /** Reads a single `Poll` that is related to this `Domain`. */
  poll?: Maybe<Poll>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Domain` mutation. */
export type CreateDomainPayloadDomainEdgeArgs = {
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};

/** All input for the create `Group` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Group` to be created by this mutation. */
  group: GroupInput;
};

/** All input for the create `GroupMembership` mutation. */
export type CreateGroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `GroupMembership` to be created by this mutation. */
  groupMembership: GroupMembershipInput;
};

/** The output of our create `GroupMembership` mutation. */
export type CreateGroupMembershipPayload = {
  __typename?: 'CreateGroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `GroupMembership`. */
  group?: Maybe<Group>;
  /** The `GroupMembership` that was created by this mutation. */
  groupMembership?: Maybe<GroupMembership>;
  /** An edge for our `GroupMembership`. May be used by Relay 1. */
  groupMembershipEdge?: Maybe<GroupMembershipsEdge>;
  /** Reads a single `User` that is related to this `GroupMembership`. */
  member?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `GroupMembership` mutation. */
export type CreateGroupMembershipPayloadGroupMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};

/** The output of our create `Group` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  createdBy?: Maybe<User>;
  /** The `Group` that was created by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Group` that is related to this `Group`. */
  parentGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Group` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

export type CreateGroupSimpleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

/** All input for the create `Log` mutation. */
export type CreateLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Log` to be created by this mutation. */
  log: LogInput;
};

/** The output of our create `Log` mutation. */
export type CreateLogPayload = {
  __typename?: 'CreateLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Log` that was created by this mutation. */
  log?: Maybe<Log>;
  /** An edge for our `Log`. May be used by Relay 1. */
  logEdge?: Maybe<LogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Log` mutation. */
export type CreateLogPayloadLogEdgeArgs = {
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};

/** All input for the create `Option` mutation. */
export type CreateOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Option` to be created by this mutation. */
  option: OptionInput;
};

/** The output of our create `Option` mutation. */
export type CreateOptionPayload = {
  __typename?: 'CreateOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Option`. */
  createdBy?: Maybe<User>;
  /** The `Option` that was created by this mutation. */
  option?: Maybe<Option>;
  /** An edge for our `Option`. May be used by Relay 1. */
  optionEdge?: Maybe<OptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Question` that is related to this `Option`. */
  question?: Maybe<Question>;
};


/** The output of our create `Option` mutation. */
export type CreateOptionPayloadOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};

/** All input for the create `Poll` mutation. */
export type CreatePollInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Poll` to be created by this mutation. */
  poll: PollInput;
};

/** The output of our create `Poll` mutation. */
export type CreatePollPayload = {
  __typename?: 'CreatePollPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Poll`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Asset` that is related to this `Poll`. */
  image?: Maybe<Asset>;
  /** The `Poll` that was created by this mutation. */
  poll?: Maybe<Poll>;
  /** An edge for our `Poll`. May be used by Relay 1. */
  pollEdge?: Maybe<PollsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Poll` mutation. */
export type CreatePollPayloadPollEdgeArgs = {
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};

/** All input for the create `Question` mutation. */
export type CreateQuestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Question` to be created by this mutation. */
  question: QuestionInput;
};

/** The output of our create `Question` mutation. */
export type CreateQuestionPayload = {
  __typename?: 'CreateQuestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Question`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Poll` that is related to this `Question`. */
  poll?: Maybe<Poll>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Question` that was created by this mutation. */
  question?: Maybe<Question>;
  /** An edge for our `Question`. May be used by Relay 1. */
  questionEdge?: Maybe<QuestionsEdge>;
};


/** The output of our create `Question` mutation. */
export type CreateQuestionPayloadQuestionEdgeArgs = {
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};

/** All input for the create `RequestsLog` mutation. */
export type CreateRequestsLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RequestsLog` to be created by this mutation. */
  requestsLog: RequestsLogInput;
};

/** The output of our create `RequestsLog` mutation. */
export type CreateRequestsLogPayload = {
  __typename?: 'CreateRequestsLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RequestsLog` that was created by this mutation. */
  requestsLog?: Maybe<RequestsLog>;
  /** An edge for our `RequestsLog`. May be used by Relay 1. */
  requestsLogEdge?: Maybe<RequestsLogsEdge>;
};


/** The output of our create `RequestsLog` mutation. */
export type CreateRequestsLogPayloadRequestsLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RequestsLogsOrderBy>>;
};

/** All input for the create `ResetPasswordToken` mutation. */
export type CreateResetPasswordTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ResetPasswordToken` to be created by this mutation. */
  resetPasswordToken: ResetPasswordTokenInput;
};

/** The output of our create `ResetPasswordToken` mutation. */
export type CreateResetPasswordTokenPayload = {
  __typename?: 'CreateResetPasswordTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ResetPasswordToken` that was created by this mutation. */
  resetPasswordToken?: Maybe<ResetPasswordToken>;
  /** An edge for our `ResetPasswordToken`. May be used by Relay 1. */
  resetPasswordTokenEdge?: Maybe<ResetPasswordTokensEdge>;
  /** Reads a single `User` that is related to this `ResetPasswordToken`. */
  user?: Maybe<User>;
};


/** The output of our create `ResetPasswordToken` mutation. */
export type CreateResetPasswordTokenPayloadResetPasswordTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<ResetPasswordTokensOrderBy>>;
};

/** All input for the create `Response` mutation. */
export type CreateResponseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Response` to be created by this mutation. */
  response: ResponseInput;
};

/** The output of our create `Response` mutation. */
export type CreateResponsePayload = {
  __typename?: 'CreateResponsePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Response`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Option` that is related to this `Response`. */
  option?: Maybe<Option>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Response` that was created by this mutation. */
  response?: Maybe<Response>;
  /** An edge for our `Response`. May be used by Relay 1. */
  responseEdge?: Maybe<ResponsesEdge>;
};


/** The output of our create `Response` mutation. */
export type CreateResponsePayloadResponseEdgeArgs = {
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserProfile` mutation. */
export type CreateUserProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserProfile` to be created by this mutation. */
  userProfile: UserProfileInput;
};

/** The output of our create `UserProfile` mutation. */
export type CreateUserProfilePayload = {
  __typename?: 'CreateUserProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserProfile`. */
  user?: Maybe<User>;
  /** The `UserProfile` that was created by this mutation. */
  userProfile?: Maybe<UserProfile>;
  /** An edge for our `UserProfile`. May be used by Relay 1. */
  userProfileEdge?: Maybe<UserProfilesEdge>;
};


/** The output of our create `UserProfile` mutation. */
export type CreateUserProfilePayloadUserProfileEdgeArgs = {
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
};

/** All input for the create `UserRole` mutation. */
export type CreateUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserRole` to be created by this mutation. */
  userRole: UserRoleInput;
};

/** The output of our create `UserRole` mutation. */
export type CreateUserRolePayload = {
  __typename?: 'CreateUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRole` that was created by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our create `UserRole` mutation. */
export type CreateUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the create `UserRoleUser` mutation. */
export type CreateUserRoleUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserRoleUser` to be created by this mutation. */
  userRoleUser: UserRoleUserInput;
};

/** The output of our create `UserRoleUser` mutation. */
export type CreateUserRoleUserPayload = {
  __typename?: 'CreateUserRoleUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRoleUser`. */
  userByUser?: Maybe<User>;
  /** Reads a single `UserRole` that is related to this `UserRoleUser`. */
  userRoleByUserRole?: Maybe<UserRole>;
  /** The `UserRoleUser` that was created by this mutation. */
  userRoleUser?: Maybe<UserRoleUser>;
  /** An edge for our `UserRoleUser`. May be used by Relay 1. */
  userRoleUserEdge?: Maybe<UserRoleUsersEdge>;
};


/** The output of our create `UserRoleUser` mutation. */
export type CreateUserRoleUserPayloadUserRoleUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleUsersOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

export type DeactivateInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the `deleteAssetByNodeId` mutation. */
export type DeleteAssetByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Asset` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteAsset` mutation. */
export type DeleteAssetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Asset` mutation. */
export type DeleteAssetPayload = {
  __typename?: 'DeleteAssetPayload';
  /** The `Asset` that was deleted by this mutation. */
  asset?: Maybe<Asset>;
  /** An edge for our `Asset`. May be used by Relay 1. */
  assetEdge?: Maybe<AssetsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Asset`. */
  createdBy?: Maybe<User>;
  deletedAssetNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Asset` mutation. */
export type DeleteAssetPayloadAssetEdgeArgs = {
  orderBy?: InputMaybe<Array<AssetsOrderBy>>;
};

/** All input for the `deleteDomainByNodeId` mutation. */
export type DeleteDomainByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Domain` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDomain` mutation. */
export type DeleteDomainInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Domain` mutation. */
export type DeleteDomainPayload = {
  __typename?: 'DeleteDomainPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Domain`. */
  createdBy?: Maybe<User>;
  deletedDomainNodeId?: Maybe<Scalars['ID']>;
  /** The `Domain` that was deleted by this mutation. */
  domain?: Maybe<Domain>;
  /** An edge for our `Domain`. May be used by Relay 1. */
  domainEdge?: Maybe<DomainsEdge>;
  /** Reads a single `Poll` that is related to this `Domain`. */
  poll?: Maybe<Poll>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Domain` mutation. */
export type DeleteDomainPayloadDomainEdgeArgs = {
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};

/** All input for the `deleteGroupByNodeId` mutation. */
export type DeleteGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Group` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteGroup` mutation. */
export type DeleteGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** All input for the `deleteGroupMembershipByNodeId` mutation. */
export type DeleteGroupMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `GroupMembership` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteGroupMembership` mutation. */
export type DeleteGroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `GroupMembership` mutation. */
export type DeleteGroupMembershipPayload = {
  __typename?: 'DeleteGroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedGroupMembershipNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `GroupMembership`. */
  group?: Maybe<Group>;
  /** The `GroupMembership` that was deleted by this mutation. */
  groupMembership?: Maybe<GroupMembership>;
  /** An edge for our `GroupMembership`. May be used by Relay 1. */
  groupMembershipEdge?: Maybe<GroupMembershipsEdge>;
  /** Reads a single `User` that is related to this `GroupMembership`. */
  member?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `GroupMembership` mutation. */
export type DeleteGroupMembershipPayloadGroupMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};

/** The output of our delete `Group` mutation. */
export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  createdBy?: Maybe<User>;
  deletedGroupNodeId?: Maybe<Scalars['ID']>;
  /** The `Group` that was deleted by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Group` that is related to this `Group`. */
  parentGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Group` mutation. */
export type DeleteGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `deleteLogByNodeId` mutation. */
export type DeleteLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Log` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteLog` mutation. */
export type DeleteLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Log` mutation. */
export type DeleteLogPayload = {
  __typename?: 'DeleteLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLogNodeId?: Maybe<Scalars['ID']>;
  /** The `Log` that was deleted by this mutation. */
  log?: Maybe<Log>;
  /** An edge for our `Log`. May be used by Relay 1. */
  logEdge?: Maybe<LogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Log` mutation. */
export type DeleteLogPayloadLogEdgeArgs = {
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};

/** All input for the `deleteOptionByNodeId` mutation. */
export type DeleteOptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Option` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOption` mutation. */
export type DeleteOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Option` mutation. */
export type DeleteOptionPayload = {
  __typename?: 'DeleteOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Option`. */
  createdBy?: Maybe<User>;
  deletedOptionNodeId?: Maybe<Scalars['ID']>;
  /** The `Option` that was deleted by this mutation. */
  option?: Maybe<Option>;
  /** An edge for our `Option`. May be used by Relay 1. */
  optionEdge?: Maybe<OptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Question` that is related to this `Option`. */
  question?: Maybe<Question>;
};


/** The output of our delete `Option` mutation. */
export type DeleteOptionPayloadOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};

/** All input for the `deletePollByNodeId` mutation. */
export type DeletePollByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Poll` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePoll` mutation. */
export type DeletePollInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Poll` mutation. */
export type DeletePollPayload = {
  __typename?: 'DeletePollPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Poll`. */
  createdBy?: Maybe<User>;
  deletedPollNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Asset` that is related to this `Poll`. */
  image?: Maybe<Asset>;
  /** The `Poll` that was deleted by this mutation. */
  poll?: Maybe<Poll>;
  /** An edge for our `Poll`. May be used by Relay 1. */
  pollEdge?: Maybe<PollsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Poll` mutation. */
export type DeletePollPayloadPollEdgeArgs = {
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};

/** All input for the `deleteQuestionByNodeId` mutation. */
export type DeleteQuestionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Question` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteQuestion` mutation. */
export type DeleteQuestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Question` mutation. */
export type DeleteQuestionPayload = {
  __typename?: 'DeleteQuestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Question`. */
  createdBy?: Maybe<User>;
  deletedQuestionNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Poll` that is related to this `Question`. */
  poll?: Maybe<Poll>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Question` that was deleted by this mutation. */
  question?: Maybe<Question>;
  /** An edge for our `Question`. May be used by Relay 1. */
  questionEdge?: Maybe<QuestionsEdge>;
};


/** The output of our delete `Question` mutation. */
export type DeleteQuestionPayloadQuestionEdgeArgs = {
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};

/** All input for the `deleteRequestsLogByNodeId` mutation. */
export type DeleteRequestsLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RequestsLog` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteRequestsLog` mutation. */
export type DeleteRequestsLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `RequestsLog` mutation. */
export type DeleteRequestsLogPayload = {
  __typename?: 'DeleteRequestsLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRequestsLogNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RequestsLog` that was deleted by this mutation. */
  requestsLog?: Maybe<RequestsLog>;
  /** An edge for our `RequestsLog`. May be used by Relay 1. */
  requestsLogEdge?: Maybe<RequestsLogsEdge>;
};


/** The output of our delete `RequestsLog` mutation. */
export type DeleteRequestsLogPayloadRequestsLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RequestsLogsOrderBy>>;
};

/** All input for the `deleteResetPasswordTokenByNodeId` mutation. */
export type DeleteResetPasswordTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ResetPasswordToken` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteResetPasswordToken` mutation. */
export type DeleteResetPasswordTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ResetPasswordToken` mutation. */
export type DeleteResetPasswordTokenPayload = {
  __typename?: 'DeleteResetPasswordTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedResetPasswordTokenNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ResetPasswordToken` that was deleted by this mutation. */
  resetPasswordToken?: Maybe<ResetPasswordToken>;
  /** An edge for our `ResetPasswordToken`. May be used by Relay 1. */
  resetPasswordTokenEdge?: Maybe<ResetPasswordTokensEdge>;
  /** Reads a single `User` that is related to this `ResetPasswordToken`. */
  user?: Maybe<User>;
};


/** The output of our delete `ResetPasswordToken` mutation. */
export type DeleteResetPasswordTokenPayloadResetPasswordTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<ResetPasswordTokensOrderBy>>;
};

/** All input for the `deleteResponseByNodeId` mutation. */
export type DeleteResponseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Response` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteResponse` mutation. */
export type DeleteResponseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Response` mutation. */
export type DeleteResponsePayload = {
  __typename?: 'DeleteResponsePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Response`. */
  createdBy?: Maybe<User>;
  deletedResponseNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Option` that is related to this `Response`. */
  option?: Maybe<Option>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Response` that was deleted by this mutation. */
  response?: Maybe<Response>;
  /** An edge for our `Response`. May be used by Relay 1. */
  responseEdge?: Maybe<ResponsesEdge>;
};


/** The output of our delete `Response` mutation. */
export type DeleteResponsePayloadResponseEdgeArgs = {
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};

/** All input for the `deleteUserByNodeId` mutation. */
export type DeleteUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserProfileByNodeId` mutation. */
export type DeleteUserProfileByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserProfile` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserProfile` mutation. */
export type DeleteUserProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `UserProfile` mutation. */
export type DeleteUserProfilePayload = {
  __typename?: 'DeleteUserProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserProfileNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserProfile`. */
  user?: Maybe<User>;
  /** The `UserProfile` that was deleted by this mutation. */
  userProfile?: Maybe<UserProfile>;
  /** An edge for our `UserProfile`. May be used by Relay 1. */
  userProfileEdge?: Maybe<UserProfilesEdge>;
};


/** The output of our delete `UserProfile` mutation. */
export type DeleteUserProfilePayloadUserProfileEdgeArgs = {
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
};

/** All input for the `deleteUserRoleByNodeId` mutation. */
export type DeleteUserRoleByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserRole` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserRole` mutation. */
export type DeleteUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `UserRole` mutation. */
export type DeleteUserRolePayload = {
  __typename?: 'DeleteUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserRoleNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRole` that was deleted by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our delete `UserRole` mutation. */
export type DeleteUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the `deleteUserRoleUserByNodeId` mutation. */
export type DeleteUserRoleUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserRoleUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserRoleUser` mutation. */
export type DeleteUserRoleUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};

/** The output of our delete `UserRoleUser` mutation. */
export type DeleteUserRoleUserPayload = {
  __typename?: 'DeleteUserRoleUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserRoleUserNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRoleUser`. */
  userByUser?: Maybe<User>;
  /** Reads a single `UserRole` that is related to this `UserRoleUser`. */
  userRoleByUserRole?: Maybe<UserRole>;
  /** The `UserRoleUser` that was deleted by this mutation. */
  userRoleUser?: Maybe<UserRoleUser>;
  /** An edge for our `UserRoleUser`. May be used by Relay 1. */
  userRoleUserEdge?: Maybe<UserRoleUsersEdge>;
};


/** The output of our delete `UserRoleUser` mutation. */
export type DeleteUserRoleUserPayloadUserRoleUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleUsersOrderBy>>;
};

export type Domain = Node & {
  __typename?: 'Domain';
  accessType: DomainsAccesstypeEnum;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Domain`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  domain: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Poll` that is related to this `Domain`. */
  poll?: Maybe<Poll>;
  pollId?: Maybe<Scalars['Int']>;
  state: DomainsStateEnum;
  updatedAt: Scalars['Datetime'];
};

/** A condition to be used against `Domain` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DomainCondition = {
  /** Checks for equality with the object’s `accessType` field. */
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `domain` field. */
  domain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `pollId` field. */
  pollId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<DomainsStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Domain` object types. All fields are combined with a logical ‘and.’ */
export type DomainFilter = {
  /** Filter by the object’s `accessType` field. */
  accessType?: InputMaybe<DomainsAccesstypeEnumFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DomainFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `domain` field. */
  domain?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DomainFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DomainFilter>>;
  /** Filter by the object’s `pollId` field. */
  pollId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<DomainsStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Domain` */
export type DomainInput = {
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domain: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk491C8241A2624E1C24B22F31830Input>;
  state?: InputMaybe<DomainsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type DomainNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `domain` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type DomainNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `domain` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type DomainOnDomainForFk491C8241A2624E1C24B22F31830NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `poll` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: PollPatch;
};

/** The fields on `domain` to look up the row to update. */
export type DomainOnDomainForFk491C8241A2624E1C24B22F31830UsingPkFe295C0C5Cd15337F5F68Ace943Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `domain` being updated. */
  patch: UpdateDomainOnDomainForFk491C8241A2624E1C24B22F31830Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type DomainOnDomainForFkCac37E9D10297530Cdef577Ce3ANodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `domain` to look up the row to update. */
export type DomainOnDomainForFkCac37E9D10297530Cdef577Ce3AUsingPkFe295C0C5Cd15337F5F68Ace943Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `domain` being updated. */
  patch: UpdateDomainOnDomainForFkCac37E9D10297530Cdef577Ce3APatch;
};

/** Represents an update to a `Domain`. Fields that are set will be updated. */
export type DomainPatch = {
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk491C8241A2624E1C24B22F31830Input>;
  state?: InputMaybe<DomainsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInput>;
};

/** The fields on `domain` to look up the row to connect. */
export type DomainPkFe295C0C5Cd15337F5F68Ace943Connect = {
  id: Scalars['Int'];
};

/** The fields on `domain` to look up the row to delete. */
export type DomainPkFe295C0C5Cd15337F5F68Ace943Delete = {
  id: Scalars['Int'];
};

export enum DomainsAccesstypeEnum {
  All = 'ALL',
  Results = 'RESULTS'
}

/** A filter to be used against DomainsAccesstypeEnum fields. All fields are combined with a logical ‘and.’ */
export type DomainsAccesstypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DomainsAccesstypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DomainsAccesstypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DomainsAccesstypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DomainsAccesstypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DomainsAccesstypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DomainsAccesstypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DomainsAccesstypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DomainsAccesstypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DomainsAccesstypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DomainsAccesstypeEnum>>;
};

/** A connection to a list of `Domain` values. */
export type DomainsConnection = {
  __typename?: 'DomainsConnection';
  /** A list of edges which contains the `Domain` and cursor to aid in pagination. */
  edges: Array<DomainsEdge>;
  /** A list of `Domain` objects. */
  nodes: Array<Maybe<Domain>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Domain` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Domain` edge in the connection. */
export type DomainsEdge = {
  __typename?: 'DomainsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Domain` at the end of the edge. */
  node?: Maybe<Domain>;
};

/** Methods to use when ordering `Domain`. */
export enum DomainsOrderBy {
  AccessTypeAsc = 'ACCESS_TYPE_ASC',
  AccessTypeDesc = 'ACCESS_TYPE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  DomainAsc = 'DOMAIN_ASC',
  DomainDesc = 'DOMAIN_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  Natural = 'NATURAL',
  PollIdAsc = 'POLL_ID_ASC',
  PollIdDesc = 'POLL_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum DomainsStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against DomainsStateEnum fields. All fields are combined with a logical ‘and.’ */
export type DomainsStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DomainsStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DomainsStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DomainsStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DomainsStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DomainsStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DomainsStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DomainsStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DomainsStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DomainsStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DomainsStateEnum>>;
};

export type FindGroupInput = {
  name?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `option` in the `ResponseInput` mutation. */
export type Fk09F98E13892E59A2129D0F0A524Input = {
  /** The primary key(s) for `option` for the far side of the relationship. */
  connectById?: InputMaybe<OptionPkC5Bb2799F041Af4E3Ac613Bdc1EConnect>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<OptionNodeIdConnect>;
  /** A `OptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk09F98E13892E59A2129D0F0A524OptionsCreateInput>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  deleteById?: InputMaybe<OptionPkC5Bb2799F041Af4E3Ac613Bdc1EDelete>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<OptionNodeIdDelete>;
  /** The primary key(s) and patch data for `option` for the far side of the relationship. */
  updateById?: InputMaybe<OptionOnResponseForFk09F98E13892E59A2129D0F0A524UsingPkC5Bb2799F041Af4E3Ac613Bdc1EUpdate>;
  /** The primary key(s) and patch data for `option` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ResponseOnResponseForFk09F98E13892E59A2129D0F0A524NodeIdUpdate>;
};

/** Input for the nested mutation of `response` in the `OptionInput` mutation. */
export type Fk09F98E13892E59A2129D0F0A524InverseInput = {
  /** The primary key(s) for `response` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ResponsePk1442Ce8148E632820C6Ded09104Connect>>;
  /** The primary key(s) for `response` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ResponseNodeIdConnect>>;
  /** A `ResponseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk09F98E13892E59A2129D0F0A524ResponsesCreateInput>>;
  /** The primary key(s) for `response` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ResponsePk1442Ce8148E632820C6Ded09104Delete>>;
  /** The primary key(s) for `response` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ResponseNodeIdDelete>>;
  /** Flag indicating whether all other `response` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `response` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ResponseOnResponseForFk09F98E13892E59A2129D0F0A524UsingPk1442Ce8148E632820C6Ded09104Update>>;
  /** The primary key(s) and patch data for `response` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<OptionOnResponseForFk09F98E13892E59A2129D0F0A524NodeIdUpdate>>;
};

/** The `option` to be created by this mutation. */
export type Fk09F98E13892E59A2129D0F0A524OptionsCreateInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** The `response` to be created by this mutation. */
export type Fk09F98E13892E59A2129D0F0A524ResponsesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionToOptionId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524Input>;
  state?: InputMaybe<ResponsesStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `groupMembership` to be created by this mutation. */
export type Fk0E57A259364Bda6568F0353B559GroupMembershipCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupToGroupId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978Input>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<GroupMembershipRoleEnum>;
  state?: InputMaybe<GroupMembershipStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToMemberId?: InputMaybe<Fk0E57A259364Bda6568F0353B559Input>;
};

/** Input for the nested mutation of `user` in the `GroupMembershipInput` mutation. */
export type Fk0E57A259364Bda6568F0353B559Input = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk0E57A259364Bda6568F0353B559UsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnGroupMembershipForFk0E57A259364Bda6568F0353B559UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<GroupMembershipOnGroupMembershipForFk0E57A259364Bda6568F0353B559NodeIdUpdate>;
};

/** Input for the nested mutation of `groupMembership` in the `UserInput` mutation. */
export type Fk0E57A259364Bda6568F0353B559InverseInput = {
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GroupMembershipPkA8C5Dbe248A0Ace11C55Aa0121AConnect>>;
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<GroupMembershipNodeIdConnect>>;
  /** A `GroupMembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk0E57A259364Bda6568F0353B559GroupMembershipCreateInput>>;
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<GroupMembershipPkA8C5Dbe248A0Ace11C55Aa0121ADelete>>;
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<GroupMembershipNodeIdDelete>>;
  /** Flag indicating whether all other `groupMembership` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `groupMembership` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GroupMembershipOnGroupMembershipForFk0E57A259364Bda6568F0353B559UsingPkA8C5Dbe248A0Ace11C55Aa0121AUpdate>>;
  /** The primary key(s) and patch data for `groupMembership` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnGroupMembershipForFk0E57A259364Bda6568F0353B559NodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type Fk0E57A259364Bda6568F0353B559UsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** Input for the nested mutation of `question` in the `OptionInput` mutation. */
export type Fk2F023042321Cac895F71085Bdc2Input = {
  /** The primary key(s) for `question` for the far side of the relationship. */
  connectById?: InputMaybe<QuestionPkD22C14C39D83D62E9Abe0E78205Connect>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<QuestionNodeIdConnect>;
  /** A `QuestionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk2F023042321Cac895F71085Bdc2QuestionsCreateInput>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  deleteById?: InputMaybe<QuestionPkD22C14C39D83D62E9Abe0E78205Delete>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<QuestionNodeIdDelete>;
  /** The primary key(s) and patch data for `question` for the far side of the relationship. */
  updateById?: InputMaybe<QuestionOnOptionForFk2F023042321Cac895F71085Bdc2UsingPkD22C14C39D83D62E9Abe0E78205Update>;
  /** The primary key(s) and patch data for `question` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OptionOnOptionForFk2F023042321Cac895F71085Bdc2NodeIdUpdate>;
};

/** Input for the nested mutation of `option` in the `QuestionInput` mutation. */
export type Fk2F023042321Cac895F71085Bdc2InverseInput = {
  /** The primary key(s) for `option` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OptionPkC5Bb2799F041Af4E3Ac613Bdc1EConnect>>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OptionNodeIdConnect>>;
  /** A `OptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk2F023042321Cac895F71085Bdc2OptionsCreateInput>>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OptionPkC5Bb2799F041Af4E3Ac613Bdc1EDelete>>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OptionNodeIdDelete>>;
  /** Flag indicating whether all other `option` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `option` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OptionOnOptionForFk2F023042321Cac895F71085Bdc2UsingPkC5Bb2799F041Af4E3Ac613Bdc1EUpdate>>;
  /** The primary key(s) and patch data for `option` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<QuestionOnOptionForFk2F023042321Cac895F71085Bdc2NodeIdUpdate>>;
};

/** The `option` to be created by this mutation. */
export type Fk2F023042321Cac895F71085Bdc2OptionsCreateInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** The `question` to be created by this mutation. */
export type Fk2F023042321Cac895F71085Bdc2QuestionsCreateInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** Input for the nested mutation of `userRole` in the `UserRoleUserInput` mutation. */
export type Fk3B1Beb6B07301C7525D24Bde7F3Input = {
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  connectById?: InputMaybe<UserRolePk294737C12B5Cc236297C8F9F7EdConnect>;
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserRoleNodeIdConnect>;
  /** A `UserRoleInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3UserRoleCreateInput>;
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  deleteById?: InputMaybe<UserRolePk294737C12B5Cc236297C8F9F7EdDelete>;
  /** The primary key(s) for `userRole` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserRoleNodeIdDelete>;
  /** The primary key(s) and patch data for `userRole` for the far side of the relationship. */
  updateById?: InputMaybe<UserRoleOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3UsingPk294737C12B5Cc236297C8F9F7EdUpdate>;
  /** The primary key(s) and patch data for `userRole` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserRoleUserOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3NodeIdUpdate>;
};

/** Input for the nested mutation of `userRoleUser` in the `UserRoleInput` mutation. */
export type Fk3B1Beb6B07301C7525D24Bde7F3InverseInput = {
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserRoleUserNodeIdConnect>>;
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  connectByUserRoleAndUser?: InputMaybe<Array<UserRoleUserPk473Af9A16C1C841F2Ca172B6276Connect>>;
  /** A `UserRoleUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk3B1Beb6B07301C7525D24Bde7F3UserRoleUsersCreateInput>>;
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserRoleUserNodeIdDelete>>;
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  deleteByUserRoleAndUser?: InputMaybe<Array<UserRoleUserPk473Af9A16C1C841F2Ca172B6276Delete>>;
  /** Flag indicating whether all other `userRoleUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userRoleUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserRoleOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3NodeIdUpdate>>;
  /** The primary key(s) and patch data for `userRoleUser` for the far side of the relationship. */
  updateByUserRoleAndUser?: InputMaybe<Array<UserRoleUserOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3UsingPk473Af9A16C1C841F2Ca172B6276Update>>;
};

/** The `userRole` to be created by this mutation. */
export type Fk3B1Beb6B07301C7525D24Bde7F3UserRoleCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  state?: InputMaybe<UserRoleStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userRoleUsersUsingId?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3InverseInput>;
  value: Scalars['String'];
};

/** The `userRoleUser` to be created by this mutation. */
export type Fk3B1Beb6B07301C7525D24Bde7F3UserRoleUsersCreateInput = {
  user?: InputMaybe<Scalars['Int']>;
  userRoleToUserRole?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3Input>;
  userToUser?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486Input>;
};

/** The `asset` to be created by this mutation. */
export type Fk3B4041F72C74134Fd253C373Ce7AssetsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mimetype?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInverseInput>;
  settings?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssetsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7Input>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `user` in the `AssetInput` mutation. */
export type Fk3B4041F72C74134Fd253C373Ce7Input = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7UsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnAssetForFk3B4041F72C74134Fd253C373Ce7UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<AssetOnAssetForFk3B4041F72C74134Fd253C373Ce7NodeIdUpdate>;
};

/** Input for the nested mutation of `asset` in the `UserInput` mutation. */
export type Fk3B4041F72C74134Fd253C373Ce7InverseInput = {
  /** The primary key(s) for `asset` for the far side of the relationship. */
  connectById?: InputMaybe<Array<AssetPkBbd9B67466Ce36Ece4B2F1E4Fd1Connect>>;
  /** The primary key(s) for `asset` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<AssetNodeIdConnect>>;
  /** A `AssetInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk3B4041F72C74134Fd253C373Ce7AssetsCreateInput>>;
  /** The primary key(s) for `asset` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<AssetPkBbd9B67466Ce36Ece4B2F1E4Fd1Delete>>;
  /** The primary key(s) for `asset` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<AssetNodeIdDelete>>;
  /** Flag indicating whether all other `asset` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `asset` for the far side of the relationship. */
  updateById?: InputMaybe<Array<AssetOnAssetForFk3B4041F72C74134Fd253C373Ce7UsingPkBbd9B67466Ce36Ece4B2F1E4Fd1Update>>;
  /** The primary key(s) and patch data for `asset` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnAssetForFk3B4041F72C74134Fd253C373Ce7NodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type Fk3B4041F72C74134Fd253C373Ce7UsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** Input for the nested mutation of `user` in the `ResetPasswordTokenInput` mutation. */
export type Fk3Da9Fdab00F2Fd15Fd801D70786Input = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786UsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ResetPasswordTokenOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786NodeIdUpdate>;
};

/** Input for the nested mutation of `resetPasswordToken` in the `UserInput` mutation. */
export type Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput = {
  /** The primary key(s) for `resetPasswordToken` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ResetPasswordTokenPk60F82Af801Ebcc82Dd42Ede8625Connect>>;
  /** The primary key(s) for `resetPasswordToken` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ResetPasswordTokenNodeIdConnect>>;
  /** A `ResetPasswordTokenInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk3Da9Fdab00F2Fd15Fd801D70786ResetPasswordTokenCreateInput>>;
  /** The primary key(s) for `resetPasswordToken` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ResetPasswordTokenPk60F82Af801Ebcc82Dd42Ede8625Delete>>;
  /** The primary key(s) for `resetPasswordToken` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ResetPasswordTokenNodeIdDelete>>;
  /** Flag indicating whether all other `resetPasswordToken` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `resetPasswordToken` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ResetPasswordTokenOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786UsingPk60F82Af801Ebcc82Dd42Ede8625Update>>;
  /** The primary key(s) and patch data for `resetPasswordToken` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786NodeIdUpdate>>;
};

/** The `resetPasswordToken` to be created by this mutation. */
export type Fk3Da9Fdab00F2Fd15Fd801D70786ResetPasswordTokenCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<ResetPasswordTokenStateEnum>;
  status?: InputMaybe<ResetPasswordTokenStatusEnum>;
  token: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786Input>;
  validUntil: Scalars['Datetime'];
};

/** The `user` to be created by this mutation. */
export type Fk3Da9Fdab00F2Fd15Fd801D70786UsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** Input for the nested mutation of `user` in the `ResponseInput` mutation. */
export type Fk5B32E635D66Db78796216Bb88FfInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfUsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnResponseForFk5B32E635D66Db78796216Bb88FfUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<ResponseOnResponseForFk5B32E635D66Db78796216Bb88FfNodeIdUpdate>;
};

/** Input for the nested mutation of `response` in the `UserInput` mutation. */
export type Fk5B32E635D66Db78796216Bb88FfInverseInput = {
  /** The primary key(s) for `response` for the far side of the relationship. */
  connectById?: InputMaybe<Array<ResponsePk1442Ce8148E632820C6Ded09104Connect>>;
  /** The primary key(s) for `response` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<ResponseNodeIdConnect>>;
  /** A `ResponseInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk5B32E635D66Db78796216Bb88FfResponsesCreateInput>>;
  /** The primary key(s) for `response` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<ResponsePk1442Ce8148E632820C6Ded09104Delete>>;
  /** The primary key(s) for `response` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<ResponseNodeIdDelete>>;
  /** Flag indicating whether all other `response` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `response` for the far side of the relationship. */
  updateById?: InputMaybe<Array<ResponseOnResponseForFk5B32E635D66Db78796216Bb88FfUsingPk1442Ce8148E632820C6Ded09104Update>>;
  /** The primary key(s) and patch data for `response` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnResponseForFk5B32E635D66Db78796216Bb88FfNodeIdUpdate>>;
};

/** The `response` to be created by this mutation. */
export type Fk5B32E635D66Db78796216Bb88FfResponsesCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionId?: InputMaybe<Scalars['Int']>;
  optionToOptionId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524Input>;
  state?: InputMaybe<ResponsesStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** The `user` to be created by this mutation. */
export type Fk5B32E635D66Db78796216Bb88FfUsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** The `group` to be created by this mutation. */
export type Fk9Abc0550Ca1C5285Fcd3Bb92978GroupCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentGroupId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** The `groupMembership` to be created by this mutation. */
export type Fk9Abc0550Ca1C5285Fcd3Bb92978GroupMembershipCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  groupToGroupId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978Input>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  memberId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<GroupMembershipRoleEnum>;
  state?: InputMaybe<GroupMembershipStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToMemberId?: InputMaybe<Fk0E57A259364Bda6568F0353B559Input>;
};

/** Input for the nested mutation of `group` in the `GroupMembershipInput` mutation. */
export type Fk9Abc0550Ca1C5285Fcd3Bb92978Input = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupPkFe845Bf655Bc27966Bd9225D968Connect>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<GroupNodeIdConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978GroupCreateInput>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  deleteById?: InputMaybe<GroupPkFe845Bf655Bc27966Bd9225D968Delete>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<GroupNodeIdDelete>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978UsingPkFe845Bf655Bc27966Bd9225D968Update>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<GroupMembershipOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978NodeIdUpdate>;
};

/** Input for the nested mutation of `groupMembership` in the `GroupInput` mutation. */
export type Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput = {
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GroupMembershipPkA8C5Dbe248A0Ace11C55Aa0121AConnect>>;
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<GroupMembershipNodeIdConnect>>;
  /** A `GroupMembershipInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk9Abc0550Ca1C5285Fcd3Bb92978GroupMembershipCreateInput>>;
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<GroupMembershipPkA8C5Dbe248A0Ace11C55Aa0121ADelete>>;
  /** The primary key(s) for `groupMembership` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<GroupMembershipNodeIdDelete>>;
  /** Flag indicating whether all other `groupMembership` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `groupMembership` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GroupMembershipOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978UsingPkA8C5Dbe248A0Ace11C55Aa0121AUpdate>>;
  /** The primary key(s) and patch data for `groupMembership` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<GroupOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978NodeIdUpdate>>;
};

/** The `asset` to be created by this mutation. */
export type Fk92Fe09641A13814B79Fec585F8EAssetsCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mimetype?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInverseInput>;
  settings?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssetsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7Input>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Input for the nested mutation of `asset` in the `PollInput` mutation. */
export type Fk92Fe09641A13814B79Fec585F8EInput = {
  /** The primary key(s) for `asset` for the far side of the relationship. */
  connectById?: InputMaybe<AssetPkBbd9B67466Ce36Ece4B2F1E4Fd1Connect>;
  /** The primary key(s) for `asset` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<AssetNodeIdConnect>;
  /** A `AssetInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EAssetsCreateInput>;
  /** The primary key(s) for `asset` for the far side of the relationship. */
  deleteById?: InputMaybe<AssetPkBbd9B67466Ce36Ece4B2F1E4Fd1Delete>;
  /** The primary key(s) for `asset` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<AssetNodeIdDelete>;
  /** The primary key(s) and patch data for `asset` for the far side of the relationship. */
  updateById?: InputMaybe<AssetOnPollForFk92Fe09641A13814B79Fec585F8EUsingPkBbd9B67466Ce36Ece4B2F1E4Fd1Update>;
  /** The primary key(s) and patch data for `asset` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PollOnPollForFk92Fe09641A13814B79Fec585F8ENodeIdUpdate>;
};

/** Input for the nested mutation of `poll` in the `AssetInput` mutation. */
export type Fk92Fe09641A13814B79Fec585F8EInverseInput = {
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PollPkE2D044445F8Cca07E3Bb68F5870Connect>>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<PollNodeIdConnect>>;
  /** A `PollInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk92Fe09641A13814B79Fec585F8EPollsCreateInput>>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PollPkE2D044445F8Cca07E3Bb68F5870Delete>>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<PollNodeIdDelete>>;
  /** Flag indicating whether all other `poll` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PollOnPollForFk92Fe09641A13814B79Fec585F8EUsingPkE2D044445F8Cca07E3Bb68F5870Update>>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<AssetOnPollForFk92Fe09641A13814B79Fec585F8ENodeIdUpdate>>;
};

/** The `poll` to be created by this mutation. */
export type Fk92Fe09641A13814B79Fec585F8EPollsCreateInput = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** Input for the nested mutation of `poll` in the `QuestionInput` mutation. */
export type Fk296Cab84E5Df7Fd60Cf3A96B0D3Input = {
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectById?: InputMaybe<PollPkE2D044445F8Cca07E3Bb68F5870Connect>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PollNodeIdConnect>;
  /** A `PollInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3PollsCreateInput>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteById?: InputMaybe<PollPkE2D044445F8Cca07E3Bb68F5870Delete>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<PollNodeIdDelete>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateById?: InputMaybe<PollOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3UsingPkE2D044445F8Cca07E3Bb68F5870Update>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<QuestionOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3NodeIdUpdate>;
};

/** Input for the nested mutation of `question` in the `PollInput` mutation. */
export type Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput = {
  /** The primary key(s) for `question` for the far side of the relationship. */
  connectById?: InputMaybe<Array<QuestionPkD22C14C39D83D62E9Abe0E78205Connect>>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<QuestionNodeIdConnect>>;
  /** A `QuestionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk296Cab84E5Df7Fd60Cf3A96B0D3QuestionsCreateInput>>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<QuestionPkD22C14C39D83D62E9Abe0E78205Delete>>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<QuestionNodeIdDelete>>;
  /** Flag indicating whether all other `question` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `question` for the far side of the relationship. */
  updateById?: InputMaybe<Array<QuestionOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3UsingPkD22C14C39D83D62E9Abe0E78205Update>>;
  /** The primary key(s) and patch data for `question` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<PollOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3NodeIdUpdate>>;
};

/** The `poll` to be created by this mutation. */
export type Fk296Cab84E5Df7Fd60Cf3A96B0D3PollsCreateInput = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** The `question` to be created by this mutation. */
export type Fk296Cab84E5Df7Fd60Cf3A96B0D3QuestionsCreateInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** The `domain` to be created by this mutation. */
export type Fk491C8241A2624E1C24B22F31830DomainsCreateInput = {
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domain: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  pollToPollId?: InputMaybe<Fk491C8241A2624E1C24B22F31830Input>;
  state?: InputMaybe<DomainsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInput>;
};

/** Input for the nested mutation of `poll` in the `DomainInput` mutation. */
export type Fk491C8241A2624E1C24B22F31830Input = {
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectById?: InputMaybe<PollPkE2D044445F8Cca07E3Bb68F5870Connect>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<PollNodeIdConnect>;
  /** A `PollInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk491C8241A2624E1C24B22F31830PollsCreateInput>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteById?: InputMaybe<PollPkE2D044445F8Cca07E3Bb68F5870Delete>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<PollNodeIdDelete>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateById?: InputMaybe<PollOnDomainForFk491C8241A2624E1C24B22F31830UsingPkE2D044445F8Cca07E3Bb68F5870Update>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DomainOnDomainForFk491C8241A2624E1C24B22F31830NodeIdUpdate>;
};

/** Input for the nested mutation of `domain` in the `PollInput` mutation. */
export type Fk491C8241A2624E1C24B22F31830InverseInput = {
  /** The primary key(s) for `domain` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DomainPkFe295C0C5Cd15337F5F68Ace943Connect>>;
  /** The primary key(s) for `domain` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DomainNodeIdConnect>>;
  /** A `DomainInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk491C8241A2624E1C24B22F31830DomainsCreateInput>>;
  /** The primary key(s) for `domain` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DomainPkFe295C0C5Cd15337F5F68Ace943Delete>>;
  /** The primary key(s) for `domain` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<DomainNodeIdDelete>>;
  /** Flag indicating whether all other `domain` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `domain` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DomainOnDomainForFk491C8241A2624E1C24B22F31830UsingPkFe295C0C5Cd15337F5F68Ace943Update>>;
  /** The primary key(s) and patch data for `domain` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<PollOnDomainForFk491C8241A2624E1C24B22F31830NodeIdUpdate>>;
};

/** The `poll` to be created by this mutation. */
export type Fk491C8241A2624E1C24B22F31830PollsCreateInput = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** Input for the nested mutation of `user` in the `OptionInput` mutation. */
export type Fk981A9Ac4A18289D79488263Ed2AInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AUsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnOptionForFk981A9Ac4A18289D79488263Ed2AUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<OptionOnOptionForFk981A9Ac4A18289D79488263Ed2ANodeIdUpdate>;
};

/** Input for the nested mutation of `option` in the `UserInput` mutation. */
export type Fk981A9Ac4A18289D79488263Ed2AInverseInput = {
  /** The primary key(s) for `option` for the far side of the relationship. */
  connectById?: InputMaybe<Array<OptionPkC5Bb2799F041Af4E3Ac613Bdc1EConnect>>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<OptionNodeIdConnect>>;
  /** A `OptionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<Fk981A9Ac4A18289D79488263Ed2AOptionsCreateInput>>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<OptionPkC5Bb2799F041Af4E3Ac613Bdc1EDelete>>;
  /** The primary key(s) for `option` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<OptionNodeIdDelete>>;
  /** Flag indicating whether all other `option` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `option` for the far side of the relationship. */
  updateById?: InputMaybe<Array<OptionOnOptionForFk981A9Ac4A18289D79488263Ed2AUsingPkC5Bb2799F041Af4E3Ac613Bdc1EUpdate>>;
  /** The primary key(s) and patch data for `option` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnOptionForFk981A9Ac4A18289D79488263Ed2ANodeIdUpdate>>;
};

/** The `option` to be created by this mutation. */
export type Fk981A9Ac4A18289D79488263Ed2AOptionsCreateInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** The `user` to be created by this mutation. */
export type Fk981A9Ac4A18289D79488263Ed2AUsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** The `group` to be created by this mutation. */
export type Fk4007De3Fa537Bbcb98599265E2DGroupCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** Input for the nested mutation of `group` in the `GroupInput` mutation. */
export type Fk4007De3Fa537Bbcb98599265E2DInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<GroupPkFe845Bf655Bc27966Bd9225D968Connect>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<GroupNodeIdConnect>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DGroupCreateInput>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  deleteById?: InputMaybe<GroupPkFe845Bf655Bc27966Bd9225D968Delete>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<GroupNodeIdDelete>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<GroupOnGroupForFk4007De3Fa537Bbcb98599265E2DUsingPkFe845Bf655Bc27966Bd9225D968Update>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<GroupOnGroupForFk4007De3Fa537Bbcb98599265E2DNodeIdUpdate>;
};

/** Input for the nested mutation of `user` in the `UserProfileInput` mutation. */
export type FkC9C0Be6396A82465Df1Cd0Ac2D3Input = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3UsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserProfileOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3NodeIdUpdate>;
};

/** Input for the nested mutation of `userProfile` in the `UserInput` mutation. */
export type FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput = {
  /** The primary key(s) for `userProfile` for the far side of the relationship. */
  connectById?: InputMaybe<Array<UserProfilePk56Bc6Da5B4B5466Fbb92D7D96B3Connect>>;
  /** The primary key(s) for `userProfile` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserProfileNodeIdConnect>>;
  /** A `UserProfileInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkC9C0Be6396A82465Df1Cd0Ac2D3UserProfileCreateInput>>;
  /** The primary key(s) for `userProfile` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<UserProfilePk56Bc6Da5B4B5466Fbb92D7D96B3Delete>>;
  /** The primary key(s) for `userProfile` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserProfileNodeIdDelete>>;
  /** Flag indicating whether all other `userProfile` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userProfile` for the far side of the relationship. */
  updateById?: InputMaybe<Array<UserProfileOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3UsingPk56Bc6Da5B4B5466Fbb92D7D96B3Update>>;
  /** The primary key(s) and patch data for `userProfile` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3NodeIdUpdate>>;
};

/** The `userProfile` to be created by this mutation. */
export type FkC9C0Be6396A82465Df1Cd0Ac2D3UserProfileCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  profileId: Scalars['String'];
  profileSecret?: InputMaybe<Scalars['String']>;
  profileType?: InputMaybe<UserProfileProfiletypeEnum>;
  state?: InputMaybe<UserProfileStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3Input>;
};

/** The `user` to be created by this mutation. */
export type FkC9C0Be6396A82465Df1Cd0Ac2D3UsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** Input for the nested mutation of `user` in the `QuestionInput` mutation. */
export type FkC9F18Abddaea39Caf78B19Bd7A2Input = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2UsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<QuestionOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2NodeIdUpdate>;
};

/** Input for the nested mutation of `question` in the `UserInput` mutation. */
export type FkC9F18Abddaea39Caf78B19Bd7A2InverseInput = {
  /** The primary key(s) for `question` for the far side of the relationship. */
  connectById?: InputMaybe<Array<QuestionPkD22C14C39D83D62E9Abe0E78205Connect>>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<QuestionNodeIdConnect>>;
  /** A `QuestionInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkC9F18Abddaea39Caf78B19Bd7A2QuestionsCreateInput>>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<QuestionPkD22C14C39D83D62E9Abe0E78205Delete>>;
  /** The primary key(s) for `question` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<QuestionNodeIdDelete>>;
  /** Flag indicating whether all other `question` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `question` for the far side of the relationship. */
  updateById?: InputMaybe<Array<QuestionOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2UsingPkD22C14C39D83D62E9Abe0E78205Update>>;
  /** The primary key(s) and patch data for `question` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2NodeIdUpdate>>;
};

/** The `question` to be created by this mutation. */
export type FkC9F18Abddaea39Caf78B19Bd7A2QuestionsCreateInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** The `user` to be created by this mutation. */
export type FkC9F18Abddaea39Caf78B19Bd7A2UsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** The `domain` to be created by this mutation. */
export type FkCac37E9D10297530Cdef577Ce3ADomainsCreateInput = {
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domain: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk491C8241A2624E1C24B22F31830Input>;
  state?: InputMaybe<DomainsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInput>;
};

/** Input for the nested mutation of `user` in the `DomainInput` mutation. */
export type FkCac37E9D10297530Cdef577Ce3AInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AUsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnDomainForFkCac37E9D10297530Cdef577Ce3AUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<DomainOnDomainForFkCac37E9D10297530Cdef577Ce3ANodeIdUpdate>;
};

/** Input for the nested mutation of `domain` in the `UserInput` mutation. */
export type FkCac37E9D10297530Cdef577Ce3AInverseInput = {
  /** The primary key(s) for `domain` for the far side of the relationship. */
  connectById?: InputMaybe<Array<DomainPkFe295C0C5Cd15337F5F68Ace943Connect>>;
  /** The primary key(s) for `domain` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<DomainNodeIdConnect>>;
  /** A `DomainInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkCac37E9D10297530Cdef577Ce3ADomainsCreateInput>>;
  /** The primary key(s) for `domain` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<DomainPkFe295C0C5Cd15337F5F68Ace943Delete>>;
  /** The primary key(s) for `domain` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<DomainNodeIdDelete>>;
  /** Flag indicating whether all other `domain` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `domain` for the far side of the relationship. */
  updateById?: InputMaybe<Array<DomainOnDomainForFkCac37E9D10297530Cdef577Ce3AUsingPkFe295C0C5Cd15337F5F68Ace943Update>>;
  /** The primary key(s) and patch data for `domain` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnDomainForFkCac37E9D10297530Cdef577Ce3ANodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FkCac37E9D10297530Cdef577Ce3AUsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** Input for the nested mutation of `user` in the `PollInput` mutation. */
export type FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AUsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0AUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<PollOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0ANodeIdUpdate>;
};

/** Input for the nested mutation of `poll` in the `UserInput` mutation. */
export type FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput = {
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectById?: InputMaybe<Array<PollPkE2D044445F8Cca07E3Bb68F5870Connect>>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<PollNodeIdConnect>>;
  /** A `PollInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkCf6219Fdbf85890Ef3Dd2Cd9B0APollsCreateInput>>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<PollPkE2D044445F8Cca07E3Bb68F5870Delete>>;
  /** The primary key(s) for `poll` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<PollNodeIdDelete>>;
  /** Flag indicating whether all other `poll` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateById?: InputMaybe<Array<PollOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0AUsingPkE2D044445F8Cca07E3Bb68F5870Update>>;
  /** The primary key(s) and patch data for `poll` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0ANodeIdUpdate>>;
};

/** The `poll` to be created by this mutation. */
export type FkCf6219Fdbf85890Ef3Dd2Cd9B0APollsCreateInput = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** The `user` to be created by this mutation. */
export type FkCf6219Fdbf85890Ef3Dd2Cd9B0AUsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** The `group` to be created by this mutation. */
export type FkEa1D696765Abe34B320C71BffbeGroupCreateInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentGroupId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** Input for the nested mutation of `user` in the `GroupInput` mutation. */
export type FkEa1D696765Abe34B320C71BffbeInput = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkEa1D696765Abe34B320C71BffbeUsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnGroupForFkEa1D696765Abe34B320C71BffbeUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<GroupOnGroupForFkEa1D696765Abe34B320C71BffbeNodeIdUpdate>;
};

/** Input for the nested mutation of `group` in the `UserInput` mutation. */
export type FkEa1D696765Abe34B320C71BffbeInverseInput = {
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectById?: InputMaybe<Array<GroupPkFe845Bf655Bc27966Bd9225D968Connect>>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<GroupNodeIdConnect>>;
  /** A `GroupInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkEa1D696765Abe34B320C71BffbeGroupCreateInput>>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  deleteById?: InputMaybe<Array<GroupPkFe845Bf655Bc27966Bd9225D968Delete>>;
  /** The primary key(s) for `group` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<GroupNodeIdDelete>>;
  /** Flag indicating whether all other `group` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateById?: InputMaybe<Array<GroupOnGroupForFkEa1D696765Abe34B320C71BffbeUsingPkFe845Bf655Bc27966Bd9225D968Update>>;
  /** The primary key(s) and patch data for `group` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnGroupForFkEa1D696765Abe34B320C71BffbeNodeIdUpdate>>;
};

/** The `user` to be created by this mutation. */
export type FkEa1D696765Abe34B320C71BffbeUsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** Input for the nested mutation of `user` in the `UserRoleUserInput` mutation. */
export type FkFcc63Bfa5Dd9E061Bb4115Db486Input = {
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<UserNodeIdConnect>;
  /** A `UserInput` object that will be created and connected to this object. */
  create?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486UsersCreateInput>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteById?: InputMaybe<UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete>;
  /** The primary key(s) for `user` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<UserNodeIdDelete>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateById?: InputMaybe<UserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update>;
  /** The primary key(s) and patch data for `user` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<UserRoleUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486NodeIdUpdate>;
};

/** Input for the nested mutation of `userRoleUser` in the `UserInput` mutation. */
export type FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput = {
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  connectByNodeId?: InputMaybe<Array<UserRoleUserNodeIdConnect>>;
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  connectByUserRoleAndUser?: InputMaybe<Array<UserRoleUserPk473Af9A16C1C841F2Ca172B6276Connect>>;
  /** A `UserRoleUserInput` object that will be created and connected to this object. */
  create?: InputMaybe<Array<FkFcc63Bfa5Dd9E061Bb4115Db486UserRoleUsersCreateInput>>;
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  deleteByNodeId?: InputMaybe<Array<UserRoleUserNodeIdDelete>>;
  /** The primary key(s) for `userRoleUser` for the far side of the relationship. */
  deleteByUserRoleAndUser?: InputMaybe<Array<UserRoleUserPk473Af9A16C1C841F2Ca172B6276Delete>>;
  /** Flag indicating whether all other `userRoleUser` records that match this relationship should be removed. */
  deleteOthers?: InputMaybe<Scalars['Boolean']>;
  /** The primary key(s) and patch data for `userRoleUser` for the far side of the relationship. */
  updateByNodeId?: InputMaybe<Array<UserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486NodeIdUpdate>>;
  /** The primary key(s) and patch data for `userRoleUser` for the far side of the relationship. */
  updateByUserRoleAndUser?: InputMaybe<Array<UserRoleUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486UsingPk473Af9A16C1C841F2Ca172B6276Update>>;
};

/** The `userRoleUser` to be created by this mutation. */
export type FkFcc63Bfa5Dd9E061Bb4115Db486UserRoleUsersCreateInput = {
  userRole?: InputMaybe<Scalars['Int']>;
  userRoleToUserRole?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3Input>;
  userToUser?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486Input>;
};

/** The `user` to be created by this mutation. */
export type FkFcc63Bfa5Dd9E061Bb4115Db486UsersCreateInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

export type Group = Node & {
  __typename?: 'Group';
  canAccess?: Maybe<ActionsAccessPayload>;
  canAddMember?: Maybe<ActionsAccessPayload>;
  canDelete?: Maybe<ActionsAccessPayload>;
  canDemoteMember?: Maybe<ActionsAccessPayload>;
  canEdit?: Maybe<ActionsAccessPayload>;
  canJoin?: Maybe<ActionsAccessPayload>;
  canPromoteMember?: Maybe<ActionsAccessPayload>;
  canRemoveMember?: Maybe<ActionsAccessPayload>;
  canRequestMembership?: Maybe<ActionsAccessPayload>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Group`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  /** Reads and enables pagination through a set of `GroupMembership`. */
  groupMemberships: GroupMembershipsConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByParentGroupId: GroupsConnection;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Group` that is related to this `Group`. */
  parentGroup?: Maybe<Group>;
  parentGroupId?: Maybe<Scalars['Int']>;
  state: GroupStateEnum;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `User`. */
  usersByGroupMembershipGroupIdAndMemberId: GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByGroupParentGroupIdAndCreatedById: GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyConnection;
};


export type GroupGroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupMembershipCondition>;
  filter?: InputMaybe<GroupMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};


export type GroupGroupsByParentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type GroupUsersByGroupMembershipGroupIdAndMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GroupUsersByGroupParentGroupIdAndCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentGroupId` field. */
  parentGroupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<GroupStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `parentGroupId` field. */
  parentGroupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GroupStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Group` */
export type GroupInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentGroupId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

export type GroupMembership = Node & {
  __typename?: 'GroupMembership';
  createdAt: Scalars['Datetime'];
  /** Reads a single `Group` that is related to this `GroupMembership`. */
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `GroupMembership`. */
  member?: Maybe<User>;
  memberId?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  role: GroupMembershipRoleEnum;
  state: GroupMembershipStateEnum;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `GroupMembership` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GroupMembershipCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `memberId` field. */
  memberId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<GroupMembershipRoleEnum>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<GroupMembershipStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `GroupMembership` object types. All fields are combined with a logical ‘and.’ */
export type GroupMembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupMembershipFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `memberId` field. */
  memberId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupMembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupMembershipFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<GroupMembershipRoleEnumFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GroupMembershipStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `GroupMembership` */
export type GroupMembershipInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupToGroupId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978Input>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  memberId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<GroupMembershipRoleEnum>;
  state?: InputMaybe<GroupMembershipStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToMemberId?: InputMaybe<Fk0E57A259364Bda6568F0353B559Input>;
};

/** The globally unique `ID` look up for the row to connect. */
export type GroupMembershipNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `groupMembership` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type GroupMembershipNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `groupMembership` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type GroupMembershipOnGroupMembershipForFk0E57A259364Bda6568F0353B559NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `groupMembership` to look up the row to update. */
export type GroupMembershipOnGroupMembershipForFk0E57A259364Bda6568F0353B559UsingPkA8C5Dbe248A0Ace11C55Aa0121AUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `groupMembership` being updated. */
  patch: UpdateGroupMembershipOnGroupMembershipForFk0E57A259364Bda6568F0353B559Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupMembershipOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `groupMembership` to look up the row to update. */
export type GroupMembershipOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978UsingPkA8C5Dbe248A0Ace11C55Aa0121AUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `groupMembership` being updated. */
  patch: UpdateGroupMembershipOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978Patch;
};

/** Represents an update to a `GroupMembership`. Fields that are set will be updated. */
export type GroupMembershipPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupToGroupId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978Input>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  memberId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<GroupMembershipRoleEnum>;
  state?: InputMaybe<GroupMembershipStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToMemberId?: InputMaybe<Fk0E57A259364Bda6568F0353B559Input>;
};

/** The fields on `groupMembership` to look up the row to connect. */
export type GroupMembershipPkA8C5Dbe248A0Ace11C55Aa0121AConnect = {
  id: Scalars['Int'];
};

/** The fields on `groupMembership` to look up the row to delete. */
export type GroupMembershipPkA8C5Dbe248A0Ace11C55Aa0121ADelete = {
  id: Scalars['Int'];
};

export enum GroupMembershipRoleEnum {
  ContentAdmin = 'CONTENT_ADMIN',
  Member = 'MEMBER',
  Owner = 'OWNER',
  UsersAdmin = 'USERS_ADMIN'
}

/** A filter to be used against GroupMembershipRoleEnum fields. All fields are combined with a logical ‘and.’ */
export type GroupMembershipRoleEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GroupMembershipRoleEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GroupMembershipRoleEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GroupMembershipRoleEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GroupMembershipRoleEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GroupMembershipRoleEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GroupMembershipRoleEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GroupMembershipRoleEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GroupMembershipRoleEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GroupMembershipRoleEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GroupMembershipRoleEnum>>;
};

export enum GroupMembershipStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against GroupMembershipStateEnum fields. All fields are combined with a logical ‘and.’ */
export type GroupMembershipStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GroupMembershipStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GroupMembershipStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GroupMembershipStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GroupMembershipStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GroupMembershipStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GroupMembershipStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GroupMembershipStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GroupMembershipStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GroupMembershipStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GroupMembershipStateEnum>>;
};

/** A connection to a list of `GroupMembership` values. */
export type GroupMembershipsConnection = {
  __typename?: 'GroupMembershipsConnection';
  /** A list of edges which contains the `GroupMembership` and cursor to aid in pagination. */
  edges: Array<GroupMembershipsEdge>;
  /** A list of `GroupMembership` objects. */
  nodes: Array<Maybe<GroupMembership>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupMembership` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GroupMembership` edge in the connection. */
export type GroupMembershipsEdge = {
  __typename?: 'GroupMembershipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GroupMembership` at the end of the edge. */
  node?: Maybe<GroupMembership>;
};

/** Methods to use when ordering `GroupMembership`. */
export enum GroupMembershipsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  GroupIdAsc = 'GROUP_ID_ASC',
  GroupIdDesc = 'GROUP_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  MemberIdAsc = 'MEMBER_ID_ASC',
  MemberIdDesc = 'MEMBER_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The globally unique `ID` look up for the row to connect. */
export type GroupNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type GroupNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `group` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnGroupForFk4007De3Fa537Bbcb98599265E2DNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnGroupForFk4007De3Fa537Bbcb98599265E2DUsingPkFe845Bf655Bc27966Bd9225D968Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnGroupForFk4007De3Fa537Bbcb98599265E2DPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnGroupForFkEa1D696765Abe34B320C71BffbeNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnGroupForFkEa1D696765Abe34B320C71BffbeUsingPkFe845Bf655Bc27966Bd9225D968Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnGroupForFkEa1D696765Abe34B320C71BffbePatch;
};

/** The globally unique `ID` look up for the row to update. */
export type GroupOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `groupMembership` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `groupMembership` being updated. */
  patch: GroupMembershipPatch;
};

/** The fields on `group` to look up the row to update. */
export type GroupOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978UsingPkFe845Bf655Bc27966Bd9225D968Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: UpdateGroupOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978Patch;
};

/** Represents an update to a `Group`. Fields that are set will be updated. */
export type GroupPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentGroupId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** The fields on `group` to look up the row to connect. */
export type GroupPkFe845Bf655Bc27966Bd9225D968Connect = {
  id: Scalars['Int'];
};

/** The fields on `group` to look up the row to delete. */
export type GroupPkFe845Bf655Bc27966Bd9225D968Delete = {
  id: Scalars['Int'];
};

export enum GroupStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against GroupStateEnum fields. All fields are combined with a logical ‘and.’ */
export type GroupStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GroupStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GroupStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GroupStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GroupStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GroupStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GroupStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GroupStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GroupStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GroupStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GroupStateEnum>>;
};

/** A connection to a list of `User` values, with data from `GroupMembership`. */
export type GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyConnection = {
  __typename?: 'GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `GroupMembership`, and the cursor to aid in pagination. */
  edges: Array<GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `GroupMembership`. */
export type GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyEdge = {
  __typename?: 'GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `GroupMembership`. */
  groupMembershipsByMemberId: GroupMembershipsConnection;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};


/** A `User` edge in the connection, with data from `GroupMembership`. */
export type GroupUsersByGroupMembershipGroupIdAndMemberIdManyToManyEdgeGroupMembershipsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupMembershipCondition>;
  filter?: InputMaybe<GroupMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Group`. */
export type GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyConnection = {
  __typename?: 'GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Group`, and the cursor to aid in pagination. */
  edges: Array<GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Group`. */
export type GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyEdge = {
  __typename?: 'GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByCreatedById: GroupsConnection;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};


/** A `User` edge in the connection, with data from `Group`. */
export type GroupUsersByGroupParentGroupIdAndCreatedByIdManyToManyEdgeGroupsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Group` at the end of the edge. */
  node?: Maybe<Group>;
};

/** Methods to use when ordering `Group`. */
export enum GroupsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentGroupIdAsc = 'PARENT_GROUP_ID_ASC',
  ParentGroupIdDesc = 'PARENT_GROUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type Log = Node & {
  __typename?: 'Log';
  createdAt: Scalars['Datetime'];
  details: Scalars['String'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  severity?: Maybe<Scalars['String']>;
  state: LogStateEnum;
  updatedAt: Scalars['Datetime'];
};

/** A condition to be used against `Log` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LogCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `severity` field. */
  severity?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<LogStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Log` object types. All fields are combined with a logical ‘and.’ */
export type LogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LogFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LogFilter>>;
  /** Filter by the object’s `severity` field. */
  severity?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<LogStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Log` */
export type LogInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<LogStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Log`. Fields that are set will be updated. */
export type LogPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  severity?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<LogStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum LogStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against LogStateEnum fields. All fields are combined with a logical ‘and.’ */
export type LogStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LogStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LogStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LogStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LogStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LogStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LogStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LogStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LogStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LogStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LogStateEnum>>;
};

/** A connection to a list of `Log` values. */
export type LogsConnection = {
  __typename?: 'LogsConnection';
  /** A list of edges which contains the `Log` and cursor to aid in pagination. */
  edges: Array<LogsEdge>;
  /** A list of `Log` objects. */
  nodes: Array<Maybe<Log>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Log` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Log` edge in the connection. */
export type LogsEdge = {
  __typename?: 'LogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Log` at the end of the edge. */
  node?: Maybe<Log>;
};

/** Methods to use when ordering `Log`. */
export enum LogsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SeverityAsc = 'SEVERITY_ASC',
  SeverityDesc = 'SEVERITY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Creates a single `Asset`. */
  createAsset?: Maybe<CreateAssetPayload>;
  /** Creates a single `Domain`. */
  createDomain?: Maybe<CreateDomainPayload>;
  /** Creates a single `Group`. */
  createGroup?: Maybe<CreateGroupPayload>;
  /** Creates a single `GroupMembership`. */
  createGroupMembership?: Maybe<CreateGroupMembershipPayload>;
  createGroupSimple?: Maybe<SimpleMutationPayload>;
  /** Creates a single `Log`. */
  createLog?: Maybe<CreateLogPayload>;
  /** Creates a single `Option`. */
  createOption?: Maybe<CreateOptionPayload>;
  /** Creates a single `Poll`. */
  createPoll?: Maybe<CreatePollPayload>;
  /** Creates a single `Question`. */
  createQuestion?: Maybe<CreateQuestionPayload>;
  /** Creates a single `RequestsLog`. */
  createRequestsLog?: Maybe<CreateRequestsLogPayload>;
  /** Creates a single `ResetPasswordToken`. */
  createResetPasswordToken?: Maybe<CreateResetPasswordTokenPayload>;
  /** Creates a single `Response`. */
  createResponse?: Maybe<CreateResponsePayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserProfile`. */
  createUserProfile?: Maybe<CreateUserProfilePayload>;
  /** Creates a single `UserRole`. */
  createUserRole?: Maybe<CreateUserRolePayload>;
  /** Creates a single `UserRoleUser`. */
  createUserRoleUser?: Maybe<CreateUserRoleUserPayload>;
  deactivateGroup?: Maybe<SimpleMutationPayload>;
  /** Deletes a single `Asset` using a unique key. */
  deleteAsset?: Maybe<DeleteAssetPayload>;
  /** Deletes a single `Asset` using its globally unique id. */
  deleteAssetByNodeId?: Maybe<DeleteAssetPayload>;
  /** Deletes a single `Domain` using a unique key. */
  deleteDomain?: Maybe<DeleteDomainPayload>;
  /** Deletes a single `Domain` using its globally unique id. */
  deleteDomainByNodeId?: Maybe<DeleteDomainPayload>;
  /** Deletes a single `Group` using a unique key. */
  deleteGroup?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `Group` using its globally unique id. */
  deleteGroupByNodeId?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `GroupMembership` using a unique key. */
  deleteGroupMembership?: Maybe<DeleteGroupMembershipPayload>;
  /** Deletes a single `GroupMembership` using its globally unique id. */
  deleteGroupMembershipByNodeId?: Maybe<DeleteGroupMembershipPayload>;
  /** Deletes a single `Log` using a unique key. */
  deleteLog?: Maybe<DeleteLogPayload>;
  /** Deletes a single `Log` using its globally unique id. */
  deleteLogByNodeId?: Maybe<DeleteLogPayload>;
  /** Deletes a single `Option` using a unique key. */
  deleteOption?: Maybe<DeleteOptionPayload>;
  /** Deletes a single `Option` using its globally unique id. */
  deleteOptionByNodeId?: Maybe<DeleteOptionPayload>;
  /** Deletes a single `Poll` using a unique key. */
  deletePoll?: Maybe<DeletePollPayload>;
  /** Deletes a single `Poll` using its globally unique id. */
  deletePollByNodeId?: Maybe<DeletePollPayload>;
  /** Deletes a single `Question` using a unique key. */
  deleteQuestion?: Maybe<DeleteQuestionPayload>;
  /** Deletes a single `Question` using its globally unique id. */
  deleteQuestionByNodeId?: Maybe<DeleteQuestionPayload>;
  /** Deletes a single `RequestsLog` using a unique key. */
  deleteRequestsLog?: Maybe<DeleteRequestsLogPayload>;
  /** Deletes a single `RequestsLog` using its globally unique id. */
  deleteRequestsLogByNodeId?: Maybe<DeleteRequestsLogPayload>;
  /** Deletes a single `ResetPasswordToken` using a unique key. */
  deleteResetPasswordToken?: Maybe<DeleteResetPasswordTokenPayload>;
  /** Deletes a single `ResetPasswordToken` using its globally unique id. */
  deleteResetPasswordTokenByNodeId?: Maybe<DeleteResetPasswordTokenPayload>;
  /** Deletes a single `Response` using a unique key. */
  deleteResponse?: Maybe<DeleteResponsePayload>;
  /** Deletes a single `Response` using its globally unique id. */
  deleteResponseByNodeId?: Maybe<DeleteResponsePayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUserByNodeId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserProfile` using a unique key. */
  deleteUserProfile?: Maybe<DeleteUserProfilePayload>;
  /** Deletes a single `UserProfile` using its globally unique id. */
  deleteUserProfileByNodeId?: Maybe<DeleteUserProfilePayload>;
  /** Deletes a single `UserRole` using a unique key. */
  deleteUserRole?: Maybe<DeleteUserRolePayload>;
  /** Deletes a single `UserRole` using its globally unique id. */
  deleteUserRoleByNodeId?: Maybe<DeleteUserRolePayload>;
  /** Deletes a single `UserRoleUser` using a unique key. */
  deleteUserRoleUser?: Maybe<DeleteUserRoleUserPayload>;
  /** Deletes a single `UserRoleUser` using its globally unique id. */
  deleteUserRoleUserByNodeId?: Maybe<DeleteUserRoleUserPayload>;
  /** Updates a single `Asset` using a unique key and a patch. */
  updateAsset?: Maybe<UpdateAssetPayload>;
  /** Updates a single `Asset` using its globally unique id and a patch. */
  updateAssetByNodeId?: Maybe<UpdateAssetPayload>;
  /** Updates a single `Domain` using a unique key and a patch. */
  updateDomain?: Maybe<UpdateDomainPayload>;
  /** Updates a single `Domain` using its globally unique id and a patch. */
  updateDomainByNodeId?: Maybe<UpdateDomainPayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroup?: Maybe<UpdateGroupPayload>;
  /** Updates a single `Group` using its globally unique id and a patch. */
  updateGroupByNodeId?: Maybe<UpdateGroupPayload>;
  /** Updates a single `GroupMembership` using a unique key and a patch. */
  updateGroupMembership?: Maybe<UpdateGroupMembershipPayload>;
  /** Updates a single `GroupMembership` using its globally unique id and a patch. */
  updateGroupMembershipByNodeId?: Maybe<UpdateGroupMembershipPayload>;
  /** Updates a single `Log` using a unique key and a patch. */
  updateLog?: Maybe<UpdateLogPayload>;
  /** Updates a single `Log` using its globally unique id and a patch. */
  updateLogByNodeId?: Maybe<UpdateLogPayload>;
  /** Updates a single `Option` using a unique key and a patch. */
  updateOption?: Maybe<UpdateOptionPayload>;
  /** Updates a single `Option` using its globally unique id and a patch. */
  updateOptionByNodeId?: Maybe<UpdateOptionPayload>;
  /** Updates a single `Poll` using a unique key and a patch. */
  updatePoll?: Maybe<UpdatePollPayload>;
  /** Updates a single `Poll` using its globally unique id and a patch. */
  updatePollByNodeId?: Maybe<UpdatePollPayload>;
  /** Updates a single `Question` using a unique key and a patch. */
  updateQuestion?: Maybe<UpdateQuestionPayload>;
  /** Updates a single `Question` using its globally unique id and a patch. */
  updateQuestionByNodeId?: Maybe<UpdateQuestionPayload>;
  /** Updates a single `RequestsLog` using a unique key and a patch. */
  updateRequestsLog?: Maybe<UpdateRequestsLogPayload>;
  /** Updates a single `RequestsLog` using its globally unique id and a patch. */
  updateRequestsLogByNodeId?: Maybe<UpdateRequestsLogPayload>;
  /** Updates a single `ResetPasswordToken` using a unique key and a patch. */
  updateResetPasswordToken?: Maybe<UpdateResetPasswordTokenPayload>;
  /** Updates a single `ResetPasswordToken` using its globally unique id and a patch. */
  updateResetPasswordTokenByNodeId?: Maybe<UpdateResetPasswordTokenPayload>;
  /** Updates a single `Response` using a unique key and a patch. */
  updateResponse?: Maybe<UpdateResponsePayload>;
  /** Updates a single `Response` using its globally unique id and a patch. */
  updateResponseByNodeId?: Maybe<UpdateResponsePayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserByNodeId?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserProfile` using a unique key and a patch. */
  updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  /** Updates a single `UserProfile` using its globally unique id and a patch. */
  updateUserProfileByNodeId?: Maybe<UpdateUserProfilePayload>;
  /** Updates a single `UserRole` using a unique key and a patch. */
  updateUserRole?: Maybe<UpdateUserRolePayload>;
  /** Updates a single `UserRole` using its globally unique id and a patch. */
  updateUserRoleByNodeId?: Maybe<UpdateUserRolePayload>;
  /** Updates a single `UserRoleUser` using a unique key and a patch. */
  updateUserRoleUser?: Maybe<UpdateUserRoleUserPayload>;
  /** Updates a single `UserRoleUser` using its globally unique id and a patch. */
  updateUserRoleUserByNodeId?: Maybe<UpdateUserRoleUserPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDomainArgs = {
  input: CreateDomainInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupMembershipArgs = {
  input: CreateGroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupSimpleArgs = {
  input?: InputMaybe<CreateGroupSimpleInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLogArgs = {
  input: CreateLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateOptionArgs = {
  input: CreateOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePollArgs = {
  input: CreatePollInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateQuestionArgs = {
  input: CreateQuestionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRequestsLogArgs = {
  input: CreateRequestsLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateResetPasswordTokenArgs = {
  input: CreateResetPasswordTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateResponseArgs = {
  input: CreateResponseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserProfileArgs = {
  input: CreateUserProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleArgs = {
  input: CreateUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserRoleUserArgs = {
  input: CreateUserRoleUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeactivateGroupArgs = {
  input?: InputMaybe<DeactivateInput>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssetArgs = {
  input: DeleteAssetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAssetByNodeIdArgs = {
  input: DeleteAssetByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDomainArgs = {
  input: DeleteDomainInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDomainByNodeIdArgs = {
  input: DeleteDomainByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupByNodeIdArgs = {
  input: DeleteGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupMembershipArgs = {
  input: DeleteGroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupMembershipByNodeIdArgs = {
  input: DeleteGroupMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLogArgs = {
  input: DeleteLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLogByNodeIdArgs = {
  input: DeleteLogByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOptionArgs = {
  input: DeleteOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteOptionByNodeIdArgs = {
  input: DeleteOptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePollArgs = {
  input: DeletePollInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePollByNodeIdArgs = {
  input: DeletePollByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteQuestionArgs = {
  input: DeleteQuestionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteQuestionByNodeIdArgs = {
  input: DeleteQuestionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRequestsLogArgs = {
  input: DeleteRequestsLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRequestsLogByNodeIdArgs = {
  input: DeleteRequestsLogByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteResetPasswordTokenArgs = {
  input: DeleteResetPasswordTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteResetPasswordTokenByNodeIdArgs = {
  input: DeleteResetPasswordTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteResponseArgs = {
  input: DeleteResponseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteResponseByNodeIdArgs = {
  input: DeleteResponseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByNodeIdArgs = {
  input: DeleteUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserProfileArgs = {
  input: DeleteUserProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserProfileByNodeIdArgs = {
  input: DeleteUserProfileByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleArgs = {
  input: DeleteUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleByNodeIdArgs = {
  input: DeleteUserRoleByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleUserArgs = {
  input: DeleteUserRoleUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserRoleUserByNodeIdArgs = {
  input: DeleteUserRoleUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssetArgs = {
  input: UpdateAssetInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAssetByNodeIdArgs = {
  input: UpdateAssetByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDomainArgs = {
  input: UpdateDomainInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDomainByNodeIdArgs = {
  input: UpdateDomainByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupByNodeIdArgs = {
  input: UpdateGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupMembershipArgs = {
  input: UpdateGroupMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupMembershipByNodeIdArgs = {
  input: UpdateGroupMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLogArgs = {
  input: UpdateLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLogByNodeIdArgs = {
  input: UpdateLogByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOptionArgs = {
  input: UpdateOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateOptionByNodeIdArgs = {
  input: UpdateOptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePollArgs = {
  input: UpdatePollInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePollByNodeIdArgs = {
  input: UpdatePollByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateQuestionArgs = {
  input: UpdateQuestionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateQuestionByNodeIdArgs = {
  input: UpdateQuestionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRequestsLogArgs = {
  input: UpdateRequestsLogInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRequestsLogByNodeIdArgs = {
  input: UpdateRequestsLogByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResetPasswordTokenArgs = {
  input: UpdateResetPasswordTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResetPasswordTokenByNodeIdArgs = {
  input: UpdateResetPasswordTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResponseArgs = {
  input: UpdateResponseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateResponseByNodeIdArgs = {
  input: UpdateResponseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByNodeIdArgs = {
  input: UpdateUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserProfileByNodeIdArgs = {
  input: UpdateUserProfileByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRoleArgs = {
  input: UpdateUserRoleInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRoleByNodeIdArgs = {
  input: UpdateUserRoleByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRoleUserArgs = {
  input: UpdateUserRoleUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserRoleUserByNodeIdArgs = {
  input: UpdateUserRoleUserByNodeIdInput;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export type Option = Node & {
  __typename?: 'Option';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Option`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  optionType?: Maybe<OptionsOptiontypeEnum>;
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Question` that is related to this `Option`. */
  question?: Maybe<Question>;
  questionId?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Response`. */
  responses: ResponsesConnection;
  state: OptionsStateEnum;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `User`. */
  usersByResponseOptionIdAndCreatedById: OptionUsersByResponseOptionIdAndCreatedByIdManyToManyConnection;
};


export type OptionResponsesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponseCondition>;
  filter?: InputMaybe<ResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};


export type OptionUsersByResponseOptionIdAndCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A condition to be used against `Option` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type OptionCondition = {
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `optionType` field. */
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `questionId` field. */
  questionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<OptionsStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Option` object types. All fields are combined with a logical ‘and.’ */
export type OptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OptionFilter>>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OptionFilter>;
  /** Filter by the object’s `optionType` field. */
  optionType?: InputMaybe<OptionsOptiontypeEnumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OptionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `questionId` field. */
  questionId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<OptionsStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Option` */
export type OptionInput = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type OptionNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `option` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type OptionNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `option` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type OptionOnOptionForFk2F023042321Cac895F71085Bdc2NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `question` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `question` being updated. */
  patch: QuestionPatch;
};

/** The fields on `option` to look up the row to update. */
export type OptionOnOptionForFk2F023042321Cac895F71085Bdc2UsingPkC5Bb2799F041Af4E3Ac613Bdc1EUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `option` being updated. */
  patch: UpdateOptionOnOptionForFk2F023042321Cac895F71085Bdc2Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type OptionOnOptionForFk981A9Ac4A18289D79488263Ed2ANodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `option` to look up the row to update. */
export type OptionOnOptionForFk981A9Ac4A18289D79488263Ed2AUsingPkC5Bb2799F041Af4E3Ac613Bdc1EUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `option` being updated. */
  patch: UpdateOptionOnOptionForFk981A9Ac4A18289D79488263Ed2APatch;
};

/** The globally unique `ID` look up for the row to update. */
export type OptionOnResponseForFk09F98E13892E59A2129D0F0A524NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `response` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `response` being updated. */
  patch: ResponsePatch;
};

/** The fields on `option` to look up the row to update. */
export type OptionOnResponseForFk09F98E13892E59A2129D0F0A524UsingPkC5Bb2799F041Af4E3Ac613Bdc1EUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `option` being updated. */
  patch: UpdateOptionOnResponseForFk09F98E13892E59A2129D0F0A524Patch;
};

/** Represents an update to a `Option`. Fields that are set will be updated. */
export type OptionPatch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** The fields on `option` to look up the row to connect. */
export type OptionPkC5Bb2799F041Af4E3Ac613Bdc1EConnect = {
  id: Scalars['Int'];
};

/** The fields on `option` to look up the row to delete. */
export type OptionPkC5Bb2799F041Af4E3Ac613Bdc1EDelete = {
  id: Scalars['Int'];
};

/** A connection to a list of `User` values, with data from `Response`. */
export type OptionUsersByResponseOptionIdAndCreatedByIdManyToManyConnection = {
  __typename?: 'OptionUsersByResponseOptionIdAndCreatedByIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Response`, and the cursor to aid in pagination. */
  edges: Array<OptionUsersByResponseOptionIdAndCreatedByIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Response`. */
export type OptionUsersByResponseOptionIdAndCreatedByIdManyToManyEdge = {
  __typename?: 'OptionUsersByResponseOptionIdAndCreatedByIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
  /** Reads and enables pagination through a set of `Response`. */
  responsesByCreatedById: ResponsesConnection;
};


/** A `User` edge in the connection, with data from `Response`. */
export type OptionUsersByResponseOptionIdAndCreatedByIdManyToManyEdgeResponsesByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponseCondition>;
  filter?: InputMaybe<ResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};

/** A connection to a list of `Option` values. */
export type OptionsConnection = {
  __typename?: 'OptionsConnection';
  /** A list of edges which contains the `Option` and cursor to aid in pagination. */
  edges: Array<OptionsEdge>;
  /** A list of `Option` objects. */
  nodes: Array<Maybe<Option>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Option` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Option` edge in the connection. */
export type OptionsEdge = {
  __typename?: 'OptionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Option` at the end of the edge. */
  node?: Maybe<Option>;
};

export enum OptionsOptiontypeEnum {
  Bool = 'BOOL',
  Initial = 'INITIAL',
  Text = 'TEXT',
  Value = 'VALUE'
}

/** A filter to be used against OptionsOptiontypeEnum fields. All fields are combined with a logical ‘and.’ */
export type OptionsOptiontypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OptionsOptiontypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OptionsOptiontypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OptionsOptiontypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OptionsOptiontypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OptionsOptiontypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OptionsOptiontypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OptionsOptiontypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OptionsOptiontypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OptionsOptiontypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OptionsOptiontypeEnum>>;
};

/** Methods to use when ordering `Option`. */
export enum OptionsOrderBy {
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  Natural = 'NATURAL',
  OptionTypeAsc = 'OPTION_TYPE_ASC',
  OptionTypeDesc = 'OPTION_TYPE_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  QuestionIdAsc = 'QUESTION_ID_ASC',
  QuestionIdDesc = 'QUESTION_ID_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum OptionsStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against OptionsStateEnum fields. All fields are combined with a logical ‘and.’ */
export type OptionsStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OptionsStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OptionsStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OptionsStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OptionsStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OptionsStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OptionsStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OptionsStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OptionsStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OptionsStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OptionsStateEnum>>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type Poll = Node & {
  __typename?: 'Poll';
  activeFrom?: Maybe<Scalars['Datetime']>;
  activeTo?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Poll`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  currentResponsesCount?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Domain`. */
  domains: DomainsConnection;
  help?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Reads a single `Asset` that is related to this `Poll`. */
  image?: Maybe<Asset>;
  imageId?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  isDeleted: Scalars['Boolean'];
  minimumResponsesCount?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  purpose?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Question`. */
  questions: QuestionsConnection;
  state: PollsStateEnum;
  title: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `User`. */
  usersByDomainPollIdAndCreatedById: PollUsersByDomainPollIdAndCreatedByIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByQuestionPollIdAndCreatedById: PollUsersByQuestionPollIdAndCreatedByIdManyToManyConnection;
};


export type PollDomainsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DomainCondition>;
  filter?: InputMaybe<DomainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};


export type PollQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionCondition>;
  filter?: InputMaybe<QuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};


export type PollUsersByDomainPollIdAndCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type PollUsersByQuestionPollIdAndCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A condition to be used against `Poll` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PollCondition = {
  /** Checks for equality with the object’s `activeFrom` field. */
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `activeTo` field. */
  activeTo?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `help` field. */
  help?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `imageId` field. */
  imageId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `imageUrl` field. */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `minimumResponsesCount` field. */
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `purpose` field. */
  purpose?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<PollsStateEnum>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Poll` object types. All fields are combined with a logical ‘and.’ */
export type PollFilter = {
  /** Filter by the object’s `activeFrom` field. */
  activeFrom?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `activeTo` field. */
  activeTo?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PollFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `help` field. */
  help?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imageId` field. */
  imageId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `imageUrl` field. */
  imageUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `minimumResponsesCount` field. */
  minimumResponsesCount?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PollFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PollFilter>>;
  /** Filter by the object’s `purpose` field. */
  purpose?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<PollsStateEnumFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Poll` */
export type PollInput = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type PollNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `poll` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type PollNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `poll` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type PollOnDomainForFk491C8241A2624E1C24B22F31830NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `domain` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `domain` being updated. */
  patch: DomainPatch;
};

/** The fields on `poll` to look up the row to update. */
export type PollOnDomainForFk491C8241A2624E1C24B22F31830UsingPkE2D044445F8Cca07E3Bb68F5870Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: UpdatePollOnDomainForFk491C8241A2624E1C24B22F31830Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type PollOnPollForFk92Fe09641A13814B79Fec585F8ENodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `asset` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `asset` being updated. */
  patch: AssetPatch;
};

/** The fields on `poll` to look up the row to update. */
export type PollOnPollForFk92Fe09641A13814B79Fec585F8EUsingPkE2D044445F8Cca07E3Bb68F5870Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: UpdatePollOnPollForFk92Fe09641A13814B79Fec585F8EPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type PollOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0ANodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `poll` to look up the row to update. */
export type PollOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0AUsingPkE2D044445F8Cca07E3Bb68F5870Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: UpdatePollOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0APatch;
};

/** The globally unique `ID` look up for the row to update. */
export type PollOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `question` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `question` being updated. */
  patch: QuestionPatch;
};

/** The fields on `poll` to look up the row to update. */
export type PollOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3UsingPkE2D044445F8Cca07E3Bb68F5870Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: UpdatePollOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3Patch;
};

/** Represents an update to a `Poll`. Fields that are set will be updated. */
export type PollPatch = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** The fields on `poll` to look up the row to connect. */
export type PollPkE2D044445F8Cca07E3Bb68F5870Connect = {
  id: Scalars['Int'];
};

/** The fields on `poll` to look up the row to delete. */
export type PollPkE2D044445F8Cca07E3Bb68F5870Delete = {
  id: Scalars['Int'];
};

export type PollResponsesSubscriptionPayload = {
  __typename?: 'PollResponsesSubscriptionPayload';
  event?: Maybe<Scalars['String']>;
  poll?: Maybe<Poll>;
};

/** A connection to a list of `User` values, with data from `Domain`. */
export type PollUsersByDomainPollIdAndCreatedByIdManyToManyConnection = {
  __typename?: 'PollUsersByDomainPollIdAndCreatedByIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Domain`, and the cursor to aid in pagination. */
  edges: Array<PollUsersByDomainPollIdAndCreatedByIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Domain`. */
export type PollUsersByDomainPollIdAndCreatedByIdManyToManyEdge = {
  __typename?: 'PollUsersByDomainPollIdAndCreatedByIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Domain`. */
  domainsByCreatedById: DomainsConnection;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};


/** A `User` edge in the connection, with data from `Domain`. */
export type PollUsersByDomainPollIdAndCreatedByIdManyToManyEdgeDomainsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DomainCondition>;
  filter?: InputMaybe<DomainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Question`. */
export type PollUsersByQuestionPollIdAndCreatedByIdManyToManyConnection = {
  __typename?: 'PollUsersByQuestionPollIdAndCreatedByIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Question`, and the cursor to aid in pagination. */
  edges: Array<PollUsersByQuestionPollIdAndCreatedByIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Question`. */
export type PollUsersByQuestionPollIdAndCreatedByIdManyToManyEdge = {
  __typename?: 'PollUsersByQuestionPollIdAndCreatedByIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
  /** Reads and enables pagination through a set of `Question`. */
  questionsByCreatedById: QuestionsConnection;
};


/** A `User` edge in the connection, with data from `Question`. */
export type PollUsersByQuestionPollIdAndCreatedByIdManyToManyEdgeQuestionsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionCondition>;
  filter?: InputMaybe<QuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};

/** A connection to a list of `Poll` values. */
export type PollsConnection = {
  __typename?: 'PollsConnection';
  /** A list of edges which contains the `Poll` and cursor to aid in pagination. */
  edges: Array<PollsEdge>;
  /** A list of `Poll` objects. */
  nodes: Array<Maybe<Poll>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Poll` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Poll` edge in the connection. */
export type PollsEdge = {
  __typename?: 'PollsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Poll` at the end of the edge. */
  node?: Maybe<Poll>;
};

/** Methods to use when ordering `Poll`. */
export enum PollsOrderBy {
  ActiveFromAsc = 'ACTIVE_FROM_ASC',
  ActiveFromDesc = 'ACTIVE_FROM_DESC',
  ActiveToAsc = 'ACTIVE_TO_ASC',
  ActiveToDesc = 'ACTIVE_TO_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  HelpAsc = 'HELP_ASC',
  HelpDesc = 'HELP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImageIdAsc = 'IMAGE_ID_ASC',
  ImageIdDesc = 'IMAGE_ID_DESC',
  ImageUrlAsc = 'IMAGE_URL_ASC',
  ImageUrlDesc = 'IMAGE_URL_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  MinimumResponsesCountAsc = 'MINIMUM_RESPONSES_COUNT_ASC',
  MinimumResponsesCountDesc = 'MINIMUM_RESPONSES_COUNT_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurposeAsc = 'PURPOSE_ASC',
  PurposeDesc = 'PURPOSE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum PollsStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against PollsStateEnum fields. All fields are combined with a logical ‘and.’ */
export type PollsStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PollsStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PollsStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PollsStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PollsStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PollsStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PollsStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PollsStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PollsStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PollsStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PollsStateEnum>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  asset?: Maybe<Asset>;
  /** Reads a single `Asset` using its globally unique `ID`. */
  assetByNodeId?: Maybe<Asset>;
  /** Reads and enables pagination through a set of `Asset`. */
  assets?: Maybe<AssetsConnection>;
  domain?: Maybe<Domain>;
  /** Reads a single `Domain` using its globally unique `ID`. */
  domainByNodeId?: Maybe<Domain>;
  /** Reads and enables pagination through a set of `Domain`. */
  domains?: Maybe<DomainsConnection>;
  findGroups?: Maybe<GroupsConnection>;
  getPollByClient?: Maybe<Poll>;
  getVersionInfo?: Maybe<Scalars['String']>;
  group?: Maybe<Group>;
  /** Reads a single `Group` using its globally unique `ID`. */
  groupByNodeId?: Maybe<Group>;
  groupMembership?: Maybe<GroupMembership>;
  /** Reads a single `GroupMembership` using its globally unique `ID`. */
  groupMembershipByNodeId?: Maybe<GroupMembership>;
  /** Reads and enables pagination through a set of `GroupMembership`. */
  groupMemberships?: Maybe<GroupMembershipsConnection>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupsConnection>;
  log?: Maybe<Log>;
  /** Reads a single `Log` using its globally unique `ID`. */
  logByNodeId?: Maybe<Log>;
  /** Reads and enables pagination through a set of `Log`. */
  logs?: Maybe<LogsConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  option?: Maybe<Option>;
  /** Reads a single `Option` using its globally unique `ID`. */
  optionByNodeId?: Maybe<Option>;
  /** Reads and enables pagination through a set of `Option`. */
  options?: Maybe<OptionsConnection>;
  poll?: Maybe<Poll>;
  /** Reads a single `Poll` using its globally unique `ID`. */
  pollByNodeId?: Maybe<Poll>;
  /** Reads and enables pagination through a set of `Poll`. */
  polls?: Maybe<PollsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  question?: Maybe<Question>;
  /** Reads a single `Question` using its globally unique `ID`. */
  questionByNodeId?: Maybe<Question>;
  /** Reads and enables pagination through a set of `Question`. */
  questions?: Maybe<QuestionsConnection>;
  requestsLog?: Maybe<RequestsLog>;
  /** Reads a single `RequestsLog` using its globally unique `ID`. */
  requestsLogByNodeId?: Maybe<RequestsLog>;
  /** Reads and enables pagination through a set of `RequestsLog`. */
  requestsLogs?: Maybe<RequestsLogsConnection>;
  resetPasswordToken?: Maybe<ResetPasswordToken>;
  /** Reads a single `ResetPasswordToken` using its globally unique `ID`. */
  resetPasswordTokenByNodeId?: Maybe<ResetPasswordToken>;
  /** Reads and enables pagination through a set of `ResetPasswordToken`. */
  resetPasswordTokens?: Maybe<ResetPasswordTokensConnection>;
  response?: Maybe<Response>;
  /** Reads a single `Response` using its globally unique `ID`. */
  responseByNodeId?: Maybe<Response>;
  /** Reads and enables pagination through a set of `Response`. */
  responses?: Maybe<ResponsesConnection>;
  user?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  userProfile?: Maybe<UserProfile>;
  /** Reads a single `UserProfile` using its globally unique `ID`. */
  userProfileByNodeId?: Maybe<UserProfile>;
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfiles?: Maybe<UserProfilesConnection>;
  userRole?: Maybe<UserRole>;
  /** Reads a single `UserRole` using its globally unique `ID`. */
  userRoleByNodeId?: Maybe<UserRole>;
  userRoleUser?: Maybe<UserRoleUser>;
  /** Reads a single `UserRoleUser` using its globally unique `ID`. */
  userRoleUserByNodeId?: Maybe<UserRoleUser>;
  /** Reads and enables pagination through a set of `UserRoleUser`. */
  userRoleUsers?: Maybe<UserRoleUsersConnection>;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRoles?: Maybe<UserRolesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAssetArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssetByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AssetCondition>;
  filter?: InputMaybe<AssetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssetsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDomainArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDomainByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDomainsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DomainCondition>;
  filter?: InputMaybe<DomainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryFindGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  input?: InputMaybe<FindGroupInput>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetPollByClientArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupMembershipArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupMembershipByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupMembershipCondition>;
  filter?: InputMaybe<GroupMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLogArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LogCondition>;
  filter?: InputMaybe<LogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOptionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOptionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OptionCondition>;
  filter?: InputMaybe<OptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPollArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPollsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionCondition>;
  filter?: InputMaybe<QuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRequestsLogArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRequestsLogByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRequestsLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RequestsLogCondition>;
  filter?: InputMaybe<RequestsLogFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RequestsLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResetPasswordTokenArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResetPasswordTokenByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResetPasswordTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResetPasswordTokenCondition>;
  filter?: InputMaybe<ResetPasswordTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResetPasswordTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryResponseArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResponseByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryResponsesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponseCondition>;
  filter?: InputMaybe<ResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfileArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfileByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleUserArgs = {
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRoleUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleUserCondition>;
  filter?: InputMaybe<UserRoleUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRoleUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type Question = Node & {
  __typename?: 'Question';
  content: Scalars['String'];
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Question`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  help?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Option`. */
  options: OptionsConnection;
  order?: Maybe<Scalars['Int']>;
  /** Reads a single `Poll` that is related to this `Question`. */
  poll?: Maybe<Poll>;
  pollId?: Maybe<Scalars['Int']>;
  state: QuestionsStateEnum;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `User`. */
  usersByOptionQuestionIdAndCreatedById: QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyConnection;
};


export type QuestionOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OptionCondition>;
  filter?: InputMaybe<OptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};


export type QuestionUsersByOptionQuestionIdAndCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/**
 * A condition to be used against `Question` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type QuestionCondition = {
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `help` field. */
  help?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `pollId` field. */
  pollId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<QuestionsStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Question` object types. All fields are combined with a logical ‘and.’ */
export type QuestionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<QuestionFilter>>;
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>;
  /** Filter by the object’s `help` field. */
  help?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<QuestionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<QuestionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<IntFilter>;
  /** Filter by the object’s `pollId` field. */
  pollId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<QuestionsStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Question` */
export type QuestionInput = {
  content: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** The globally unique `ID` look up for the row to connect. */
export type QuestionNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `question` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type QuestionNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `question` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type QuestionOnOptionForFk2F023042321Cac895F71085Bdc2NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `option` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `option` being updated. */
  patch: OptionPatch;
};

/** The fields on `question` to look up the row to update. */
export type QuestionOnOptionForFk2F023042321Cac895F71085Bdc2UsingPkD22C14C39D83D62E9Abe0E78205Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `question` being updated. */
  patch: UpdateQuestionOnOptionForFk2F023042321Cac895F71085Bdc2Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type QuestionOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `poll` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: PollPatch;
};

/** The fields on `question` to look up the row to update. */
export type QuestionOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3UsingPkD22C14C39D83D62E9Abe0E78205Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `question` being updated. */
  patch: UpdateQuestionOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type QuestionOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `question` to look up the row to update. */
export type QuestionOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2UsingPkD22C14C39D83D62E9Abe0E78205Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `question` being updated. */
  patch: UpdateQuestionOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2Patch;
};

/** Represents an update to a `Question`. Fields that are set will be updated. */
export type QuestionPatch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** The fields on `question` to look up the row to connect. */
export type QuestionPkD22C14C39D83D62E9Abe0E78205Connect = {
  id: Scalars['Int'];
};

/** The fields on `question` to look up the row to delete. */
export type QuestionPkD22C14C39D83D62E9Abe0E78205Delete = {
  id: Scalars['Int'];
};

/** A connection to a list of `User` values, with data from `Option`. */
export type QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyConnection = {
  __typename?: 'QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Option`, and the cursor to aid in pagination. */
  edges: Array<QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Option`. */
export type QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyEdge = {
  __typename?: 'QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
  /** Reads and enables pagination through a set of `Option`. */
  optionsByCreatedById: OptionsConnection;
};


/** A `User` edge in the connection, with data from `Option`. */
export type QuestionUsersByOptionQuestionIdAndCreatedByIdManyToManyEdgeOptionsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OptionCondition>;
  filter?: InputMaybe<OptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};

/** A connection to a list of `Question` values. */
export type QuestionsConnection = {
  __typename?: 'QuestionsConnection';
  /** A list of edges which contains the `Question` and cursor to aid in pagination. */
  edges: Array<QuestionsEdge>;
  /** A list of `Question` objects. */
  nodes: Array<Maybe<Question>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Question` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Question` edge in the connection. */
export type QuestionsEdge = {
  __typename?: 'QuestionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Question` at the end of the edge. */
  node?: Maybe<Question>;
};

/** Methods to use when ordering `Question`. */
export enum QuestionsOrderBy {
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  HelpAsc = 'HELP_ASC',
  HelpDesc = 'HELP_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PollIdAsc = 'POLL_ID_ASC',
  PollIdDesc = 'POLL_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum QuestionsStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against QuestionsStateEnum fields. All fields are combined with a logical ‘and.’ */
export type QuestionsStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<QuestionsStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<QuestionsStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<QuestionsStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<QuestionsStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<QuestionsStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<QuestionsStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<QuestionsStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<QuestionsStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<QuestionsStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<QuestionsStateEnum>>;
};

export type RequestsLog = Node & {
  __typename?: 'RequestsLog';
  clientIp: Scalars['String'];
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  method: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  payload?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  state: RequestsLogStateEnum;
  updatedAt: Scalars['Datetime'];
  userId?: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `RequestsLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RequestsLogCondition = {
  /** Checks for equality with the object’s `clientIp` field. */
  clientIp?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `method` field. */
  method?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `payload` field. */
  payload?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `sessionId` field. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<RequestsLogStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `RequestsLog` object types. All fields are combined with a logical ‘and.’ */
export type RequestsLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RequestsLogFilter>>;
  /** Filter by the object’s `clientIp` field. */
  clientIp?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `method` field. */
  method?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RequestsLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RequestsLogFilter>>;
  /** Filter by the object’s `payload` field. */
  payload?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sessionId` field. */
  sessionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<RequestsLogStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `RequestsLog` */
export type RequestsLogInput = {
  clientIp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<RequestsLogStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `RequestsLog`. Fields that are set will be updated. */
export type RequestsLogPatch = {
  clientIp?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<RequestsLogStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum RequestsLogStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against RequestsLogStateEnum fields. All fields are combined with a logical ‘and.’ */
export type RequestsLogStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RequestsLogStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RequestsLogStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RequestsLogStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RequestsLogStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RequestsLogStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RequestsLogStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RequestsLogStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RequestsLogStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RequestsLogStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RequestsLogStateEnum>>;
};

/** A connection to a list of `RequestsLog` values. */
export type RequestsLogsConnection = {
  __typename?: 'RequestsLogsConnection';
  /** A list of edges which contains the `RequestsLog` and cursor to aid in pagination. */
  edges: Array<RequestsLogsEdge>;
  /** A list of `RequestsLog` objects. */
  nodes: Array<Maybe<RequestsLog>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RequestsLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RequestsLog` edge in the connection. */
export type RequestsLogsEdge = {
  __typename?: 'RequestsLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RequestsLog` at the end of the edge. */
  node?: Maybe<RequestsLog>;
};

/** Methods to use when ordering `RequestsLog`. */
export enum RequestsLogsOrderBy {
  ClientIpAsc = 'CLIENT_IP_ASC',
  ClientIpDesc = 'CLIENT_IP_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  MethodAsc = 'METHOD_ASC',
  MethodDesc = 'METHOD_DESC',
  Natural = 'NATURAL',
  PayloadAsc = 'PAYLOAD_ASC',
  PayloadDesc = 'PAYLOAD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SessionIdAsc = 'SESSION_ID_ASC',
  SessionIdDesc = 'SESSION_ID_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type ResetPasswordToken = Node & {
  __typename?: 'ResetPasswordToken';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  state: ResetPasswordTokenStateEnum;
  status: ResetPasswordTokenStatusEnum;
  token: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `ResetPasswordToken`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']>;
  validUntil: Scalars['Datetime'];
};

/**
 * A condition to be used against `ResetPasswordToken` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ResetPasswordTokenCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Checks for equality with the object’s `token` field. */
  token?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `validUntil` field. */
  validUntil?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ResetPasswordToken` object types. All fields are combined with a logical ‘and.’ */
export type ResetPasswordTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ResetPasswordTokenFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ResetPasswordTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ResetPasswordTokenFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<ResetPasswordTokenStateEnumFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ResetPasswordTokenStatusEnumFilter>;
  /** Filter by the object’s `token` field. */
  token?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `validUntil` field. */
  validUntil?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `ResetPasswordToken` */
export type ResetPasswordTokenInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<ResetPasswordTokenStateEnum>;
  status?: InputMaybe<ResetPasswordTokenStatusEnum>;
  token: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
  userToUserId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786Input>;
  validUntil: Scalars['Datetime'];
};

/** The globally unique `ID` look up for the row to connect. */
export type ResetPasswordTokenNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `resetPasswordToken` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ResetPasswordTokenNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `resetPasswordToken` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ResetPasswordTokenOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `resetPasswordToken` to look up the row to update. */
export type ResetPasswordTokenOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786UsingPk60F82Af801Ebcc82Dd42Ede8625Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `resetPasswordToken` being updated. */
  patch: UpdateResetPasswordTokenOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786Patch;
};

/** Represents an update to a `ResetPasswordToken`. Fields that are set will be updated. */
export type ResetPasswordTokenPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<ResetPasswordTokenStateEnum>;
  status?: InputMaybe<ResetPasswordTokenStatusEnum>;
  token?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
  userToUserId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786Input>;
  validUntil?: InputMaybe<Scalars['Datetime']>;
};

/** The fields on `resetPasswordToken` to look up the row to connect. */
export type ResetPasswordTokenPk60F82Af801Ebcc82Dd42Ede8625Connect = {
  id: Scalars['Int'];
};

/** The fields on `resetPasswordToken` to look up the row to delete. */
export type ResetPasswordTokenPk60F82Af801Ebcc82Dd42Ede8625Delete = {
  id: Scalars['Int'];
};

export enum ResetPasswordTokenStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against ResetPasswordTokenStateEnum fields. All fields are combined with a logical ‘and.’ */
export type ResetPasswordTokenStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ResetPasswordTokenStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ResetPasswordTokenStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ResetPasswordTokenStateEnum>>;
};

export enum ResetPasswordTokenStatusEnum {
  Generated = 'GENERATED',
  Invalid = 'INVALID',
  Redeemed = 'REDEEMED',
  Sent = 'SENT'
}

/** A filter to be used against ResetPasswordTokenStatusEnum fields. All fields are combined with a logical ‘and.’ */
export type ResetPasswordTokenStatusEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ResetPasswordTokenStatusEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ResetPasswordTokenStatusEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ResetPasswordTokenStatusEnum>>;
};

/** A connection to a list of `ResetPasswordToken` values. */
export type ResetPasswordTokensConnection = {
  __typename?: 'ResetPasswordTokensConnection';
  /** A list of edges which contains the `ResetPasswordToken` and cursor to aid in pagination. */
  edges: Array<ResetPasswordTokensEdge>;
  /** A list of `ResetPasswordToken` objects. */
  nodes: Array<Maybe<ResetPasswordToken>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ResetPasswordToken` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ResetPasswordToken` edge in the connection. */
export type ResetPasswordTokensEdge = {
  __typename?: 'ResetPasswordTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `ResetPasswordToken` at the end of the edge. */
  node?: Maybe<ResetPasswordToken>;
};

/** Methods to use when ordering `ResetPasswordToken`. */
export enum ResetPasswordTokensOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TokenAsc = 'TOKEN_ASC',
  TokenDesc = 'TOKEN_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValidUntilAsc = 'VALID_UNTIL_ASC',
  ValidUntilDesc = 'VALID_UNTIL_DESC'
}

export type Response = Node & {
  __typename?: 'Response';
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Response`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Option` that is related to this `Response`. */
  option?: Maybe<Option>;
  optionId?: Maybe<Scalars['Int']>;
  state: ResponsesStateEnum;
  updatedAt: Scalars['Datetime'];
  userId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `Response` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ResponseCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `optionId` field. */
  optionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ResponsesStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Response` object types. All fields are combined with a logical ‘and.’ */
export type ResponseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ResponseFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ResponseFilter>;
  /** Filter by the object’s `optionId` field. */
  optionId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ResponseFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<ResponsesStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `Response` */
export type ResponseInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionId?: InputMaybe<Scalars['Int']>;
  optionToOptionId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524Input>;
  state?: InputMaybe<ResponsesStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** The globally unique `ID` look up for the row to connect. */
export type ResponseNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `response` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type ResponseNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `response` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type ResponseOnResponseForFk09F98E13892E59A2129D0F0A524NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `option` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `option` being updated. */
  patch: OptionPatch;
};

/** The fields on `response` to look up the row to update. */
export type ResponseOnResponseForFk09F98E13892E59A2129D0F0A524UsingPk1442Ce8148E632820C6Ded09104Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `response` being updated. */
  patch: UpdateResponseOnResponseForFk09F98E13892E59A2129D0F0A524Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type ResponseOnResponseForFk5B32E635D66Db78796216Bb88FfNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `response` to look up the row to update. */
export type ResponseOnResponseForFk5B32E635D66Db78796216Bb88FfUsingPk1442Ce8148E632820C6Ded09104Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `response` being updated. */
  patch: UpdateResponseOnResponseForFk5B32E635D66Db78796216Bb88FfPatch;
};

/** Represents an update to a `Response`. Fields that are set will be updated. */
export type ResponsePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionId?: InputMaybe<Scalars['Int']>;
  optionToOptionId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524Input>;
  state?: InputMaybe<ResponsesStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `response` to look up the row to connect. */
export type ResponsePk1442Ce8148E632820C6Ded09104Connect = {
  id: Scalars['Int'];
};

/** The fields on `response` to look up the row to delete. */
export type ResponsePk1442Ce8148E632820C6Ded09104Delete = {
  id: Scalars['Int'];
};

/** A connection to a list of `Response` values. */
export type ResponsesConnection = {
  __typename?: 'ResponsesConnection';
  /** A list of edges which contains the `Response` and cursor to aid in pagination. */
  edges: Array<ResponsesEdge>;
  /** A list of `Response` objects. */
  nodes: Array<Maybe<Response>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Response` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Response` edge in the connection. */
export type ResponsesEdge = {
  __typename?: 'ResponsesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Response` at the end of the edge. */
  node?: Maybe<Response>;
};

/** Methods to use when ordering `Response`. */
export enum ResponsesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CreatedByIdAsc = 'CREATED_BY_ID_ASC',
  CreatedByIdDesc = 'CREATED_BY_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  Natural = 'NATURAL',
  OptionIdAsc = 'OPTION_ID_ASC',
  OptionIdDesc = 'OPTION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

export enum ResponsesStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against ResponsesStateEnum fields. All fields are combined with a logical ‘and.’ */
export type ResponsesStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ResponsesStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ResponsesStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ResponsesStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ResponsesStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ResponsesStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ResponsesStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ResponsesStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ResponsesStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ResponsesStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ResponsesStateEnum>>;
};

export type SimpleMutationPayload = {
  __typename?: 'SimpleMutationPayload';
  id?: Maybe<Scalars['String']>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when there is a new response: */
  newResponseAdded?: Maybe<PollResponsesSubscriptionPayload>;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionNewResponseAddedArgs = {
  id: Scalars['Int'];
};

/** All input for the `updateAssetByNodeId` mutation. */
export type UpdateAssetByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Asset` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Asset` being updated. */
  patch: AssetPatch;
};

/** All input for the `updateAsset` mutation. */
export type UpdateAssetInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Asset` being updated. */
  patch: AssetPatch;
};

/** The output of our update `Asset` mutation. */
export type UpdateAssetPayload = {
  __typename?: 'UpdateAssetPayload';
  /** The `Asset` that was updated by this mutation. */
  asset?: Maybe<Asset>;
  /** An edge for our `Asset`. May be used by Relay 1. */
  assetEdge?: Maybe<AssetsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Asset`. */
  createdBy?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Asset` mutation. */
export type UpdateAssetPayloadAssetEdgeArgs = {
  orderBy?: InputMaybe<Array<AssetsOrderBy>>;
};

/** All input for the `updateDomainByNodeId` mutation. */
export type UpdateDomainByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Domain` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Domain` being updated. */
  patch: DomainPatch;
};

/** All input for the `updateDomain` mutation. */
export type UpdateDomainInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Domain` being updated. */
  patch: DomainPatch;
};

/** The output of our update `Domain` mutation. */
export type UpdateDomainPayload = {
  __typename?: 'UpdateDomainPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Domain`. */
  createdBy?: Maybe<User>;
  /** The `Domain` that was updated by this mutation. */
  domain?: Maybe<Domain>;
  /** An edge for our `Domain`. May be used by Relay 1. */
  domainEdge?: Maybe<DomainsEdge>;
  /** Reads a single `Poll` that is related to this `Domain`. */
  poll?: Maybe<Poll>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Domain` mutation. */
export type UpdateDomainPayloadDomainEdgeArgs = {
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};

/** All input for the `updateGroupByNodeId` mutation. */
export type UpdateGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Group` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** All input for the `updateGroup` mutation. */
export type UpdateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** All input for the `updateGroupMembershipByNodeId` mutation. */
export type UpdateGroupMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `GroupMembership` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `GroupMembership` being updated. */
  patch: GroupMembershipPatch;
};

/** All input for the `updateGroupMembership` mutation. */
export type UpdateGroupMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `GroupMembership` being updated. */
  patch: GroupMembershipPatch;
};

/** The output of our update `GroupMembership` mutation. */
export type UpdateGroupMembershipPayload = {
  __typename?: 'UpdateGroupMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `GroupMembership`. */
  group?: Maybe<Group>;
  /** The `GroupMembership` that was updated by this mutation. */
  groupMembership?: Maybe<GroupMembership>;
  /** An edge for our `GroupMembership`. May be used by Relay 1. */
  groupMembershipEdge?: Maybe<GroupMembershipsEdge>;
  /** Reads a single `User` that is related to this `GroupMembership`. */
  member?: Maybe<User>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `GroupMembership` mutation. */
export type UpdateGroupMembershipPayloadGroupMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};

/** The output of our update `Group` mutation. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  createdBy?: Maybe<User>;
  /** The `Group` that was updated by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `Group` that is related to this `Group`. */
  parentGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Group` mutation. */
export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `updateLogByNodeId` mutation. */
export type UpdateLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Log` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Log` being updated. */
  patch: LogPatch;
};

/** All input for the `updateLog` mutation. */
export type UpdateLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Log` being updated. */
  patch: LogPatch;
};

/** The output of our update `Log` mutation. */
export type UpdateLogPayload = {
  __typename?: 'UpdateLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Log` that was updated by this mutation. */
  log?: Maybe<Log>;
  /** An edge for our `Log`. May be used by Relay 1. */
  logEdge?: Maybe<LogsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Log` mutation. */
export type UpdateLogPayloadLogEdgeArgs = {
  orderBy?: InputMaybe<Array<LogsOrderBy>>;
};

/** All input for the `updateOptionByNodeId` mutation. */
export type UpdateOptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Option` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Option` being updated. */
  patch: OptionPatch;
};

/** All input for the `updateOption` mutation. */
export type UpdateOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Option` being updated. */
  patch: OptionPatch;
};

/** The output of our update `Option` mutation. */
export type UpdateOptionPayload = {
  __typename?: 'UpdateOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Option`. */
  createdBy?: Maybe<User>;
  /** The `Option` that was updated by this mutation. */
  option?: Maybe<Option>;
  /** An edge for our `Option`. May be used by Relay 1. */
  optionEdge?: Maybe<OptionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Question` that is related to this `Option`. */
  question?: Maybe<Question>;
};


/** The output of our update `Option` mutation. */
export type UpdateOptionPayloadOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};

/** All input for the `updatePollByNodeId` mutation. */
export type UpdatePollByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Poll` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Poll` being updated. */
  patch: PollPatch;
};

/** All input for the `updatePoll` mutation. */
export type UpdatePollInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Poll` being updated. */
  patch: PollPatch;
};

/** The output of our update `Poll` mutation. */
export type UpdatePollPayload = {
  __typename?: 'UpdatePollPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Poll`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Asset` that is related to this `Poll`. */
  image?: Maybe<Asset>;
  /** The `Poll` that was updated by this mutation. */
  poll?: Maybe<Poll>;
  /** An edge for our `Poll`. May be used by Relay 1. */
  pollEdge?: Maybe<PollsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Poll` mutation. */
export type UpdatePollPayloadPollEdgeArgs = {
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};

/** All input for the `updateQuestionByNodeId` mutation. */
export type UpdateQuestionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Question` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Question` being updated. */
  patch: QuestionPatch;
};

/** All input for the `updateQuestion` mutation. */
export type UpdateQuestionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Question` being updated. */
  patch: QuestionPatch;
};

/** The output of our update `Question` mutation. */
export type UpdateQuestionPayload = {
  __typename?: 'UpdateQuestionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Question`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Poll` that is related to this `Question`. */
  poll?: Maybe<Poll>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Question` that was updated by this mutation. */
  question?: Maybe<Question>;
  /** An edge for our `Question`. May be used by Relay 1. */
  questionEdge?: Maybe<QuestionsEdge>;
};


/** The output of our update `Question` mutation. */
export type UpdateQuestionPayloadQuestionEdgeArgs = {
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};

/** All input for the `updateRequestsLogByNodeId` mutation. */
export type UpdateRequestsLogByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RequestsLog` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RequestsLog` being updated. */
  patch: RequestsLogPatch;
};

/** All input for the `updateRequestsLog` mutation. */
export type UpdateRequestsLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `RequestsLog` being updated. */
  patch: RequestsLogPatch;
};

/** The output of our update `RequestsLog` mutation. */
export type UpdateRequestsLogPayload = {
  __typename?: 'UpdateRequestsLogPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RequestsLog` that was updated by this mutation. */
  requestsLog?: Maybe<RequestsLog>;
  /** An edge for our `RequestsLog`. May be used by Relay 1. */
  requestsLogEdge?: Maybe<RequestsLogsEdge>;
};


/** The output of our update `RequestsLog` mutation. */
export type UpdateRequestsLogPayloadRequestsLogEdgeArgs = {
  orderBy?: InputMaybe<Array<RequestsLogsOrderBy>>;
};

/** All input for the `updateResetPasswordTokenByNodeId` mutation. */
export type UpdateResetPasswordTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ResetPasswordToken` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ResetPasswordToken` being updated. */
  patch: ResetPasswordTokenPatch;
};

/** All input for the `updateResetPasswordToken` mutation. */
export type UpdateResetPasswordTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ResetPasswordToken` being updated. */
  patch: ResetPasswordTokenPatch;
};

/** The output of our update `ResetPasswordToken` mutation. */
export type UpdateResetPasswordTokenPayload = {
  __typename?: 'UpdateResetPasswordTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ResetPasswordToken` that was updated by this mutation. */
  resetPasswordToken?: Maybe<ResetPasswordToken>;
  /** An edge for our `ResetPasswordToken`. May be used by Relay 1. */
  resetPasswordTokenEdge?: Maybe<ResetPasswordTokensEdge>;
  /** Reads a single `User` that is related to this `ResetPasswordToken`. */
  user?: Maybe<User>;
};


/** The output of our update `ResetPasswordToken` mutation. */
export type UpdateResetPasswordTokenPayloadResetPasswordTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<ResetPasswordTokensOrderBy>>;
};

/** All input for the `updateResponseByNodeId` mutation. */
export type UpdateResponseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Response` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Response` being updated. */
  patch: ResponsePatch;
};

/** All input for the `updateResponse` mutation. */
export type UpdateResponseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Response` being updated. */
  patch: ResponsePatch;
};

/** The output of our update `Response` mutation. */
export type UpdateResponsePayload = {
  __typename?: 'UpdateResponsePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Response`. */
  createdBy?: Maybe<User>;
  /** Reads a single `Option` that is related to this `Response`. */
  option?: Maybe<Option>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Response` that was updated by this mutation. */
  response?: Maybe<Response>;
  /** An edge for our `Response`. May be used by Relay 1. */
  responseEdge?: Maybe<ResponsesEdge>;
};


/** The output of our update `Response` mutation. */
export type UpdateResponsePayloadResponseEdgeArgs = {
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};

/** All input for the `updateUserByNodeId` mutation. */
export type UpdateUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserProfileByNodeId` mutation. */
export type UpdateUserProfileByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserProfile` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserProfile` being updated. */
  patch: UserProfilePatch;
};

/** All input for the `updateUserProfile` mutation. */
export type UpdateUserProfileInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UserProfile` being updated. */
  patch: UserProfilePatch;
};

/** The output of our update `UserProfile` mutation. */
export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserProfile`. */
  user?: Maybe<User>;
  /** The `UserProfile` that was updated by this mutation. */
  userProfile?: Maybe<UserProfile>;
  /** An edge for our `UserProfile`. May be used by Relay 1. */
  userProfileEdge?: Maybe<UserProfilesEdge>;
};


/** The output of our update `UserProfile` mutation. */
export type UpdateUserProfilePayloadUserProfileEdgeArgs = {
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
};

/** All input for the `updateUserRoleByNodeId` mutation. */
export type UpdateUserRoleByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserRole` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserRole` being updated. */
  patch: UserRolePatch;
};

/** All input for the `updateUserRole` mutation. */
export type UpdateUserRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UserRole` being updated. */
  patch: UserRolePatch;
};

/** The output of our update `UserRole` mutation. */
export type UpdateUserRolePayload = {
  __typename?: 'UpdateUserRolePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserRole` that was updated by this mutation. */
  userRole?: Maybe<UserRole>;
  /** An edge for our `UserRole`. May be used by Relay 1. */
  userRoleEdge?: Maybe<UserRolesEdge>;
};


/** The output of our update `UserRole` mutation. */
export type UpdateUserRolePayloadUserRoleEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** All input for the `updateUserRoleUserByNodeId` mutation. */
export type UpdateUserRoleUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserRoleUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserRoleUser` being updated. */
  patch: UserRoleUserPatch;
};

/** All input for the `updateUserRoleUser` mutation. */
export type UpdateUserRoleUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UserRoleUser` being updated. */
  patch: UserRoleUserPatch;
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};

/** The output of our update `UserRoleUser` mutation. */
export type UpdateUserRoleUserPayload = {
  __typename?: 'UpdateUserRoleUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserRoleUser`. */
  userByUser?: Maybe<User>;
  /** Reads a single `UserRole` that is related to this `UserRoleUser`. */
  userRoleByUserRole?: Maybe<UserRole>;
  /** The `UserRoleUser` that was updated by this mutation. */
  userRoleUser?: Maybe<UserRoleUser>;
  /** An edge for our `UserRoleUser`. May be used by Relay 1. */
  userRoleUserEdge?: Maybe<UserRoleUsersEdge>;
};


/** The output of our update `UserRoleUser` mutation. */
export type UpdateUserRoleUserPayloadUserRoleUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UserRoleUsersOrderBy>>;
};

export type User = Node & {
  __typename?: 'User';
  /** Reads and enables pagination through a set of `Asset`. */
  assetsByCreatedById: AssetsConnection;
  /** Reads and enables pagination through a set of `Asset`. */
  assetsByPollCreatedByIdAndImageId: UserAssetsByPollCreatedByIdAndImageIdManyToManyConnection;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Domain`. */
  domainsByCreatedById: DomainsConnection;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `GroupMembership`. */
  groupMembershipsByMemberId: GroupMembershipsConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByCreatedById: GroupsConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByGroupCreatedByIdAndParentGroupId: UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByGroupMembershipMemberIdAndGroupId: UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyConnection;
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Option`. */
  optionsByCreatedById: OptionsConnection;
  /** Reads and enables pagination through a set of `Option`. */
  optionsByResponseCreatedByIdAndOptionId: UserOptionsByResponseCreatedByIdAndOptionIdManyToManyConnection;
  password: Scalars['String'];
  /** Reads and enables pagination through a set of `Poll`. */
  pollsByCreatedById: PollsConnection;
  /** Reads and enables pagination through a set of `Poll`. */
  pollsByDomainCreatedByIdAndPollId: UserPollsByDomainCreatedByIdAndPollIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Poll`. */
  pollsByQuestionCreatedByIdAndPollId: UserPollsByQuestionCreatedByIdAndPollIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Question`. */
  questionsByCreatedById: QuestionsConnection;
  /** Reads and enables pagination through a set of `Question`. */
  questionsByOptionCreatedByIdAndQuestionId: UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ResetPasswordToken`. */
  resetPasswordTokens: ResetPasswordTokensConnection;
  /** Reads and enables pagination through a set of `Response`. */
  responsesByCreatedById: ResponsesConnection;
  state: UsersStateEnum;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UserProfile`. */
  userProfiles: UserProfilesConnection;
  /** Reads and enables pagination through a set of `UserRoleUser`. */
  userRoleUsersByUser: UserRoleUsersConnection;
  /** Reads and enables pagination through a set of `UserRole`. */
  userRolesByUserRoleUserUserAndUserRole: UserUserRolesByUserRoleUserUserAndUserRoleManyToManyConnection;
};


export type UserAssetsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AssetCondition>;
  filter?: InputMaybe<AssetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssetsOrderBy>>;
};


export type UserAssetsByPollCreatedByIdAndImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AssetCondition>;
  filter?: InputMaybe<AssetFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssetsOrderBy>>;
};


export type UserDomainsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DomainCondition>;
  filter?: InputMaybe<DomainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};


export type UserGroupMembershipsByMemberIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupMembershipCondition>;
  filter?: InputMaybe<GroupMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};


export type UserGroupsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsByGroupCreatedByIdAndParentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserGroupsByGroupMembershipMemberIdAndGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserOptionsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OptionCondition>;
  filter?: InputMaybe<OptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};


export type UserOptionsByResponseCreatedByIdAndOptionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OptionCondition>;
  filter?: InputMaybe<OptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};


export type UserPollsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};


export type UserPollsByDomainCreatedByIdAndPollIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};


export type UserPollsByQuestionCreatedByIdAndPollIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};


export type UserQuestionsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionCondition>;
  filter?: InputMaybe<QuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};


export type UserQuestionsByOptionCreatedByIdAndQuestionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionCondition>;
  filter?: InputMaybe<QuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};


export type UserResetPasswordTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResetPasswordTokenCondition>;
  filter?: InputMaybe<ResetPasswordTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResetPasswordTokensOrderBy>>;
};


export type UserResponsesByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponseCondition>;
  filter?: InputMaybe<ResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};


export type UserUserProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserProfileCondition>;
  filter?: InputMaybe<UserProfileFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserProfilesOrderBy>>;
};


export type UserUserRoleUsersByUserArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleUserCondition>;
  filter?: InputMaybe<UserRoleUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRoleUsersOrderBy>>;
};


export type UserUserRolesByUserRoleUserUserAndUserRoleArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleCondition>;
  filter?: InputMaybe<UserRoleFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRolesOrderBy>>;
};

/** A connection to a list of `Asset` values, with data from `Poll`. */
export type UserAssetsByPollCreatedByIdAndImageIdManyToManyConnection = {
  __typename?: 'UserAssetsByPollCreatedByIdAndImageIdManyToManyConnection';
  /** A list of edges which contains the `Asset`, info from the `Poll`, and the cursor to aid in pagination. */
  edges: Array<UserAssetsByPollCreatedByIdAndImageIdManyToManyEdge>;
  /** A list of `Asset` objects. */
  nodes: Array<Maybe<Asset>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Asset` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Asset` edge in the connection, with data from `Poll`. */
export type UserAssetsByPollCreatedByIdAndImageIdManyToManyEdge = {
  __typename?: 'UserAssetsByPollCreatedByIdAndImageIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Asset` at the end of the edge. */
  node?: Maybe<Asset>;
  /** Reads and enables pagination through a set of `Poll`. */
  pollsByImageId: PollsConnection;
};


/** A `Asset` edge in the connection, with data from `Poll`. */
export type UserAssetsByPollCreatedByIdAndImageIdManyToManyEdgePollsByImageIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PollCondition>;
  filter?: InputMaybe<PollFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PollsOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `firstName` field. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `lastName` field. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `password` field. */
  password?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<UsersStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>;
  /** Filter by the object’s `firstName` field. */
  firstName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lastName` field. */
  lastName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `password` field. */
  password?: InputMaybe<StringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<UsersStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `Group` values, with data from `Group`. */
export type UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyConnection = {
  __typename?: 'UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyConnection';
  /** A list of edges which contains the `Group`, info from the `Group`, and the cursor to aid in pagination. */
  edges: Array<UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Group` edge in the connection, with data from `Group`. */
export type UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyEdge = {
  __typename?: 'UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByParentGroupId: GroupsConnection;
  /** The `Group` at the end of the edge. */
  node?: Maybe<Group>;
};


/** A `Group` edge in the connection, with data from `Group`. */
export type UserGroupsByGroupCreatedByIdAndParentGroupIdManyToManyEdgeGroupsByParentGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** A connection to a list of `Group` values, with data from `GroupMembership`. */
export type UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyConnection = {
  __typename?: 'UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyConnection';
  /** A list of edges which contains the `Group`, info from the `GroupMembership`, and the cursor to aid in pagination. */
  edges: Array<UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyEdge>;
  /** A list of `Group` objects. */
  nodes: Array<Maybe<Group>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Group` edge in the connection, with data from `GroupMembership`. */
export type UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyEdge = {
  __typename?: 'UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `GroupMembership`. */
  groupMemberships: GroupMembershipsConnection;
  /** The `Group` at the end of the edge. */
  node?: Maybe<Group>;
};


/** A `Group` edge in the connection, with data from `GroupMembership`. */
export type UserGroupsByGroupMembershipMemberIdAndGroupIdManyToManyEdgeGroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupMembershipCondition>;
  filter?: InputMaybe<GroupMembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupMembershipsOrderBy>>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password: Scalars['String'];
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `user` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnAssetForFk3B4041F72C74134Fd253C373Ce7NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `asset` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `asset` being updated. */
  patch: AssetPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnAssetForFk3B4041F72C74134Fd253C373Ce7UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnAssetForFk3B4041F72C74134Fd253C373Ce7Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnDomainForFkCac37E9D10297530Cdef577Ce3ANodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `domain` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `domain` being updated. */
  patch: DomainPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnDomainForFkCac37E9D10297530Cdef577Ce3AUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnDomainForFkCac37E9D10297530Cdef577Ce3APatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnGroupForFkEa1D696765Abe34B320C71BffbeNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `group` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `group` being updated. */
  patch: GroupPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnGroupForFkEa1D696765Abe34B320C71BffbeUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnGroupForFkEa1D696765Abe34B320C71BffbePatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnGroupMembershipForFk0E57A259364Bda6568F0353B559NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `groupMembership` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `groupMembership` being updated. */
  patch: GroupMembershipPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnGroupMembershipForFk0E57A259364Bda6568F0353B559UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnGroupMembershipForFk0E57A259364Bda6568F0353B559Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnOptionForFk981A9Ac4A18289D79488263Ed2ANodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `option` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `option` being updated. */
  patch: OptionPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnOptionForFk981A9Ac4A18289D79488263Ed2AUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnOptionForFk981A9Ac4A18289D79488263Ed2APatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0ANodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `poll` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `poll` being updated. */
  patch: PollPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0AUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0APatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `question` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `question` being updated. */
  patch: QuestionPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `resetPasswordToken` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `resetPasswordToken` being updated. */
  patch: ResetPasswordTokenPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnResponseForFk5B32E635D66Db78796216Bb88FfNodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `response` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `response` being updated. */
  patch: ResponsePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnResponseForFk5B32E635D66Db78796216Bb88FfUsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnResponseForFk5B32E635D66Db78796216Bb88FfPatch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userProfile` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `userProfile` being updated. */
  patch: UserProfilePatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3Patch;
};

/** The globally unique `ID` look up for the row to update. */
export type UserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userRoleUser` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `userRoleUser` being updated. */
  patch: UserRoleUserPatch;
};

/** The fields on `user` to look up the row to update. */
export type UserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486UsingPkA6Cc71Bedf15A41A5F5Ee8Aea97Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UpdateUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486Patch;
};

/** A connection to a list of `Option` values, with data from `Response`. */
export type UserOptionsByResponseCreatedByIdAndOptionIdManyToManyConnection = {
  __typename?: 'UserOptionsByResponseCreatedByIdAndOptionIdManyToManyConnection';
  /** A list of edges which contains the `Option`, info from the `Response`, and the cursor to aid in pagination. */
  edges: Array<UserOptionsByResponseCreatedByIdAndOptionIdManyToManyEdge>;
  /** A list of `Option` objects. */
  nodes: Array<Maybe<Option>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Option` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Option` edge in the connection, with data from `Response`. */
export type UserOptionsByResponseCreatedByIdAndOptionIdManyToManyEdge = {
  __typename?: 'UserOptionsByResponseCreatedByIdAndOptionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Option` at the end of the edge. */
  node?: Maybe<Option>;
  /** Reads and enables pagination through a set of `Response`. */
  responses: ResponsesConnection;
};


/** A `Option` edge in the connection, with data from `Response`. */
export type UserOptionsByResponseCreatedByIdAndOptionIdManyToManyEdgeResponsesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ResponseCondition>;
  filter?: InputMaybe<ResponseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ResponsesOrderBy>>;
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** The fields on `user` to look up the row to connect. */
export type UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Connect = {
  id: Scalars['Int'];
};

/** The fields on `user` to look up the row to delete. */
export type UserPkA6Cc71Bedf15A41A5F5Ee8Aea97Delete = {
  id: Scalars['Int'];
};

/** A connection to a list of `Poll` values, with data from `Domain`. */
export type UserPollsByDomainCreatedByIdAndPollIdManyToManyConnection = {
  __typename?: 'UserPollsByDomainCreatedByIdAndPollIdManyToManyConnection';
  /** A list of edges which contains the `Poll`, info from the `Domain`, and the cursor to aid in pagination. */
  edges: Array<UserPollsByDomainCreatedByIdAndPollIdManyToManyEdge>;
  /** A list of `Poll` objects. */
  nodes: Array<Maybe<Poll>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Poll` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Poll` edge in the connection, with data from `Domain`. */
export type UserPollsByDomainCreatedByIdAndPollIdManyToManyEdge = {
  __typename?: 'UserPollsByDomainCreatedByIdAndPollIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** Reads and enables pagination through a set of `Domain`. */
  domains: DomainsConnection;
  /** The `Poll` at the end of the edge. */
  node?: Maybe<Poll>;
};


/** A `Poll` edge in the connection, with data from `Domain`. */
export type UserPollsByDomainCreatedByIdAndPollIdManyToManyEdgeDomainsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DomainCondition>;
  filter?: InputMaybe<DomainFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DomainsOrderBy>>;
};

/** A connection to a list of `Poll` values, with data from `Question`. */
export type UserPollsByQuestionCreatedByIdAndPollIdManyToManyConnection = {
  __typename?: 'UserPollsByQuestionCreatedByIdAndPollIdManyToManyConnection';
  /** A list of edges which contains the `Poll`, info from the `Question`, and the cursor to aid in pagination. */
  edges: Array<UserPollsByQuestionCreatedByIdAndPollIdManyToManyEdge>;
  /** A list of `Poll` objects. */
  nodes: Array<Maybe<Poll>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Poll` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Poll` edge in the connection, with data from `Question`. */
export type UserPollsByQuestionCreatedByIdAndPollIdManyToManyEdge = {
  __typename?: 'UserPollsByQuestionCreatedByIdAndPollIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Poll` at the end of the edge. */
  node?: Maybe<Poll>;
  /** Reads and enables pagination through a set of `Question`. */
  questions: QuestionsConnection;
};


/** A `Poll` edge in the connection, with data from `Question`. */
export type UserPollsByQuestionCreatedByIdAndPollIdManyToManyEdgeQuestionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<QuestionCondition>;
  filter?: InputMaybe<QuestionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<QuestionsOrderBy>>;
};

export type UserProfile = Node & {
  __typename?: 'UserProfile';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  profileId: Scalars['String'];
  profileSecret?: Maybe<Scalars['String']>;
  profileType: UserProfileProfiletypeEnum;
  state: UserProfileStateEnum;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserProfile`. */
  user?: Maybe<User>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UserProfile` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserProfileCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `profileId` field. */
  profileId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `profileSecret` field. */
  profileSecret?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `profileType` field. */
  profileType?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<UserProfileStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserProfile` object types. All fields are combined with a logical ‘and.’ */
export type UserProfileFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserProfileFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserProfileFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserProfileFilter>>;
  /** Filter by the object’s `profileId` field. */
  profileId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `profileSecret` field. */
  profileSecret?: InputMaybe<StringFilter>;
  /** Filter by the object’s `profileType` field. */
  profileType?: InputMaybe<UserProfileProfiletypeEnumFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<UserProfileStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserProfile` */
export type UserProfileInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  profileId: Scalars['String'];
  profileSecret?: InputMaybe<Scalars['String']>;
  profileType?: InputMaybe<UserProfileProfiletypeEnum>;
  state?: InputMaybe<UserProfileStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
  userToUserId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3Input>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserProfileNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userProfile` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserProfileNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userProfile` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserProfileOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `userProfile` to look up the row to update. */
export type UserProfileOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3UsingPk56Bc6Da5B4B5466Fbb92D7D96B3Update = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `userProfile` being updated. */
  patch: UpdateUserProfileOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3Patch;
};

/** Represents an update to a `UserProfile`. Fields that are set will be updated. */
export type UserProfilePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  profileId?: InputMaybe<Scalars['String']>;
  profileSecret?: InputMaybe<Scalars['String']>;
  profileType?: InputMaybe<UserProfileProfiletypeEnum>;
  state?: InputMaybe<UserProfileStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
  userToUserId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3Input>;
};

/** The fields on `userProfile` to look up the row to connect. */
export type UserProfilePk56Bc6Da5B4B5466Fbb92D7D96B3Connect = {
  id: Scalars['Int'];
};

/** The fields on `userProfile` to look up the row to delete. */
export type UserProfilePk56Bc6Da5B4B5466Fbb92D7D96B3Delete = {
  id: Scalars['Int'];
};

export enum UserProfileProfiletypeEnum {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Local = 'LOCAL',
  Undefined = 'UNDEFINED'
}

/** A filter to be used against UserProfileProfiletypeEnum fields. All fields are combined with a logical ‘and.’ */
export type UserProfileProfiletypeEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserProfileProfiletypeEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserProfileProfiletypeEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserProfileProfiletypeEnum>>;
};

export enum UserProfileStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against UserProfileStateEnum fields. All fields are combined with a logical ‘and.’ */
export type UserProfileStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserProfileStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserProfileStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserProfileStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserProfileStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserProfileStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserProfileStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserProfileStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserProfileStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserProfileStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserProfileStateEnum>>;
};

/** A connection to a list of `UserProfile` values. */
export type UserProfilesConnection = {
  __typename?: 'UserProfilesConnection';
  /** A list of edges which contains the `UserProfile` and cursor to aid in pagination. */
  edges: Array<UserProfilesEdge>;
  /** A list of `UserProfile` objects. */
  nodes: Array<Maybe<UserProfile>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserProfile` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserProfile` edge in the connection. */
export type UserProfilesEdge = {
  __typename?: 'UserProfilesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserProfile` at the end of the edge. */
  node?: Maybe<UserProfile>;
};

/** Methods to use when ordering `UserProfile`. */
export enum UserProfilesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProfileIdAsc = 'PROFILE_ID_ASC',
  ProfileIdDesc = 'PROFILE_ID_DESC',
  ProfileSecretAsc = 'PROFILE_SECRET_ASC',
  ProfileSecretDesc = 'PROFILE_SECRET_DESC',
  ProfileTypeAsc = 'PROFILE_TYPE_ASC',
  ProfileTypeDesc = 'PROFILE_TYPE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `Question` values, with data from `Option`. */
export type UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyConnection = {
  __typename?: 'UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyConnection';
  /** A list of edges which contains the `Question`, info from the `Option`, and the cursor to aid in pagination. */
  edges: Array<UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyEdge>;
  /** A list of `Question` objects. */
  nodes: Array<Maybe<Question>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Question` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Question` edge in the connection, with data from `Option`. */
export type UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyEdge = {
  __typename?: 'UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Question` at the end of the edge. */
  node?: Maybe<Question>;
  /** Reads and enables pagination through a set of `Option`. */
  options: OptionsConnection;
};


/** A `Question` edge in the connection, with data from `Option`. */
export type UserQuestionsByOptionCreatedByIdAndQuestionIdManyToManyEdgeOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<OptionCondition>;
  filter?: InputMaybe<OptionFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OptionsOrderBy>>;
};

export type UserRole = Node & {
  __typename?: 'UserRole';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  state: UserRoleStateEnum;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UserRoleUser`. */
  userRoleUsersByUserRole: UserRoleUsersConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserRoleUserUserRoleAndUser: UserRoleUsersByUserRoleUserUserRoleAndUserManyToManyConnection;
  value: Scalars['String'];
};


export type UserRoleUserRoleUsersByUserRoleArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserRoleUserCondition>;
  filter?: InputMaybe<UserRoleUserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserRoleUsersOrderBy>>;
};


export type UserRoleUsersByUserRoleUserUserRoleAndUserArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/**
 * A condition to be used against `UserRole` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserRoleCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<UserRoleStateEnum>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `UserRole` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isDeleted` field. */
  isDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleFilter>>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<UserRoleStateEnumFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `value` field. */
  value?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `UserRole` */
export type UserRoleInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  state?: InputMaybe<UserRoleStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userRoleUsersUsingId?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3InverseInput>;
  value: Scalars['String'];
};

/** The globally unique `ID` look up for the row to connect. */
export type UserRoleNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userRole` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserRoleNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userRole` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserRoleOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userRoleUser` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `userRoleUser` being updated. */
  patch: UserRoleUserPatch;
};

/** The fields on `userRole` to look up the row to update. */
export type UserRoleOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3UsingPk294737C12B5Cc236297C8F9F7EdUpdate = {
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `userRole` being updated. */
  patch: UpdateUserRoleOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3Patch;
};

/** Represents an update to a `UserRole`. Fields that are set will be updated. */
export type UserRolePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<UserRoleStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userRoleUsersUsingId?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3InverseInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** The fields on `userRole` to look up the row to connect. */
export type UserRolePk294737C12B5Cc236297C8F9F7EdConnect = {
  id: Scalars['Int'];
};

/** The fields on `userRole` to look up the row to delete. */
export type UserRolePk294737C12B5Cc236297C8F9F7EdDelete = {
  id: Scalars['Int'];
};

export enum UserRoleStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against UserRoleStateEnum fields. All fields are combined with a logical ‘and.’ */
export type UserRoleStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserRoleStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserRoleStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserRoleStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserRoleStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserRoleStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserRoleStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserRoleStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserRoleStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserRoleStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserRoleStateEnum>>;
};

export type UserRoleUser = Node & {
  __typename?: 'UserRoleUser';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  user: Scalars['Int'];
  /** Reads a single `User` that is related to this `UserRoleUser`. */
  userByUser?: Maybe<User>;
  userRole: Scalars['Int'];
  /** Reads a single `UserRole` that is related to this `UserRoleUser`. */
  userRoleByUserRole?: Maybe<UserRole>;
};

/**
 * A condition to be used against `UserRoleUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserRoleUserCondition = {
  /** Checks for equality with the object’s `user` field. */
  user?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userRole` field. */
  userRole?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserRoleUser` object types. All fields are combined with a logical ‘and.’ */
export type UserRoleUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserRoleUserFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<UserRoleUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserRoleUserFilter>>;
  /** Filter by the object’s `user` field. */
  user?: InputMaybe<IntFilter>;
  /** Filter by the object’s `userRole` field. */
  userRole?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `UserRoleUser` */
export type UserRoleUserInput = {
  user?: InputMaybe<Scalars['Int']>;
  userRole?: InputMaybe<Scalars['Int']>;
  userRoleToUserRole?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3Input>;
  userToUser?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486Input>;
};

/** The globally unique `ID` look up for the row to connect. */
export type UserRoleUserNodeIdConnect = {
  /** The globally unique `ID` which identifies a single `userRoleUser` to be connected. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to delete. */
export type UserRoleUserNodeIdDelete = {
  /** The globally unique `ID` which identifies a single `userRoleUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserRoleUserOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `userRole` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `userRole` being updated. */
  patch: UserRolePatch;
};

/** The fields on `userRoleUser` to look up the row to update. */
export type UserRoleUserOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3UsingPk473Af9A16C1C841F2Ca172B6276Update = {
  /** An object where the defined keys will be set on the `userRoleUser` being updated. */
  patch: UpdateUserRoleUserOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3Patch;
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};

/** The globally unique `ID` look up for the row to update. */
export type UserRoleUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486NodeIdUpdate = {
  /** The globally unique `ID` which identifies a single `user` to be connected. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `user` being updated. */
  patch: UserPatch;
};

/** The fields on `userRoleUser` to look up the row to update. */
export type UserRoleUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486UsingPk473Af9A16C1C841F2Ca172B6276Update = {
  /** An object where the defined keys will be set on the `userRoleUser` being updated. */
  patch: UpdateUserRoleUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486Patch;
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};

/** Represents an update to a `UserRoleUser`. Fields that are set will be updated. */
export type UserRoleUserPatch = {
  user?: InputMaybe<Scalars['Int']>;
  userRole?: InputMaybe<Scalars['Int']>;
  userRoleToUserRole?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3Input>;
  userToUser?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486Input>;
};

/** The fields on `userRoleUser` to look up the row to connect. */
export type UserRoleUserPk473Af9A16C1C841F2Ca172B6276Connect = {
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};

/** The fields on `userRoleUser` to look up the row to delete. */
export type UserRoleUserPk473Af9A16C1C841F2Ca172B6276Delete = {
  user: Scalars['Int'];
  userRole: Scalars['Int'];
};

/** A connection to a list of `User` values, with data from `UserRoleUser`. */
export type UserRoleUsersByUserRoleUserUserRoleAndUserManyToManyConnection = {
  __typename?: 'UserRoleUsersByUserRoleUserUserRoleAndUserManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserRoleUser`, and the cursor to aid in pagination. */
  edges: Array<UserRoleUsersByUserRoleUserUserRoleAndUserManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UserRoleUser`. */
export type UserRoleUsersByUserRoleUserUserRoleAndUserManyToManyEdge = {
  __typename?: 'UserRoleUsersByUserRoleUserUserRoleAndUserManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** A connection to a list of `UserRoleUser` values. */
export type UserRoleUsersConnection = {
  __typename?: 'UserRoleUsersConnection';
  /** A list of edges which contains the `UserRoleUser` and cursor to aid in pagination. */
  edges: Array<UserRoleUsersEdge>;
  /** A list of `UserRoleUser` objects. */
  nodes: Array<Maybe<UserRoleUser>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRoleUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserRoleUser` edge in the connection. */
export type UserRoleUsersEdge = {
  __typename?: 'UserRoleUsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserRoleUser` at the end of the edge. */
  node?: Maybe<UserRoleUser>;
};

/** Methods to use when ordering `UserRoleUser`. */
export enum UserRoleUsersOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserAsc = 'USER_ASC',
  UserDesc = 'USER_DESC',
  UserRoleAsc = 'USER_ROLE_ASC',
  UserRoleDesc = 'USER_ROLE_DESC'
}

/** A connection to a list of `UserRole` values. */
export type UserRolesConnection = {
  __typename?: 'UserRolesConnection';
  /** A list of edges which contains the `UserRole` and cursor to aid in pagination. */
  edges: Array<UserRolesEdge>;
  /** A list of `UserRole` objects. */
  nodes: Array<Maybe<UserRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserRole` edge in the connection. */
export type UserRolesEdge = {
  __typename?: 'UserRolesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserRole` at the end of the edge. */
  node?: Maybe<UserRole>;
};

/** Methods to use when ordering `UserRole`. */
export enum UserRolesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC'
}

/** A connection to a list of `UserRole` values, with data from `UserRoleUser`. */
export type UserUserRolesByUserRoleUserUserAndUserRoleManyToManyConnection = {
  __typename?: 'UserUserRolesByUserRoleUserUserAndUserRoleManyToManyConnection';
  /** A list of edges which contains the `UserRole`, info from the `UserRoleUser`, and the cursor to aid in pagination. */
  edges: Array<UserUserRolesByUserRoleUserUserAndUserRoleManyToManyEdge>;
  /** A list of `UserRole` objects. */
  nodes: Array<Maybe<UserRole>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserRole` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserRole` edge in the connection, with data from `UserRoleUser`. */
export type UserUserRolesByUserRoleUserUserAndUserRoleManyToManyEdge = {
  __typename?: 'UserUserRolesByUserRoleUserUserAndUserRoleManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserRole` at the end of the edge. */
  node?: Maybe<UserRole>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<User>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node?: Maybe<User>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstNameAsc = 'FIRST_NAME_ASC',
  FirstNameDesc = 'FIRST_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsDeletedAsc = 'IS_DELETED_ASC',
  IsDeletedDesc = 'IS_DELETED_DESC',
  LastNameAsc = 'LAST_NAME_ASC',
  LastNameDesc = 'LAST_NAME_DESC',
  Natural = 'NATURAL',
  PasswordAsc = 'PASSWORD_ASC',
  PasswordDesc = 'PASSWORD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum UsersStateEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Initial = 'INITIAL'
}

/** A filter to be used against UsersStateEnum fields. All fields are combined with a logical ‘and.’ */
export type UsersStateEnumFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UsersStateEnum>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UsersStateEnum>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UsersStateEnum>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UsersStateEnum>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UsersStateEnum>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UsersStateEnum>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UsersStateEnum>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UsersStateEnum>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UsersStateEnum>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UsersStateEnum>>;
};

/** An object where the defined keys will be set on the `asset` being updated. */
export type UpdateAssetOnAssetForFk3B4041F72C74134Fd253C373Ce7Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mimetype?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInverseInput>;
  settings?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssetsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7Input>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `asset` being updated. */
export type UpdateAssetOnPollForFk92Fe09641A13814B79Fec585F8EPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  filename?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  mimetype?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInverseInput>;
  settings?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AssetsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7Input>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `domain` being updated. */
export type UpdateDomainOnDomainForFk491C8241A2624E1C24B22F31830Patch = {
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  pollToPollId?: InputMaybe<Fk491C8241A2624E1C24B22F31830Input>;
  state?: InputMaybe<DomainsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInput>;
};

/** An object where the defined keys will be set on the `domain` being updated. */
export type UpdateDomainOnDomainForFkCac37E9D10297530Cdef577Ce3APatch = {
  accessType?: InputMaybe<DomainsAccesstypeEnum>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domain?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk491C8241A2624E1C24B22F31830Input>;
  state?: InputMaybe<DomainsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInput>;
};

/** An object where the defined keys will be set on the `groupMembership` being updated. */
export type UpdateGroupMembershipOnGroupMembershipForFk0E57A259364Bda6568F0353B559Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  groupId?: InputMaybe<Scalars['Int']>;
  groupToGroupId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978Input>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<GroupMembershipRoleEnum>;
  state?: InputMaybe<GroupMembershipStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToMemberId?: InputMaybe<Fk0E57A259364Bda6568F0353B559Input>;
};

/** An object where the defined keys will be set on the `groupMembership` being updated. */
export type UpdateGroupMembershipOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  groupToGroupId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978Input>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  memberId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<GroupMembershipRoleEnum>;
  state?: InputMaybe<GroupMembershipStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToMemberId?: InputMaybe<Fk0E57A259364Bda6568F0353B559Input>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnGroupForFk4007De3Fa537Bbcb98599265E2DPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnGroupForFkEa1D696765Abe34B320C71BffbePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentGroupId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** An object where the defined keys will be set on the `group` being updated. */
export type UpdateGroupOnGroupMembershipForFk9Abc0550Ca1C5285Fcd3Bb92978Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk9Abc0550Ca1C5285Fcd3Bb92978InverseInput>;
  groupToParentGroupId?: InputMaybe<Fk4007De3Fa537Bbcb98599265E2DInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  parentGroupId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<GroupStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInput>;
};

/** An object where the defined keys will be set on the `option` being updated. */
export type UpdateOptionOnOptionForFk2F023042321Cac895F71085Bdc2Patch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** An object where the defined keys will be set on the `option` being updated. */
export type UpdateOptionOnOptionForFk981A9Ac4A18289D79488263Ed2APatch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** An object where the defined keys will be set on the `option` being updated. */
export type UpdateOptionOnResponseForFk09F98E13892E59A2129D0F0A524Patch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionType?: InputMaybe<OptionsOptiontypeEnum>;
  order?: InputMaybe<Scalars['Int']>;
  questionId?: InputMaybe<Scalars['Int']>;
  questionToQuestionId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2Input>;
  responsesUsingId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524InverseInput>;
  state?: InputMaybe<OptionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInput>;
};

/** An object where the defined keys will be set on the `poll` being updated. */
export type UpdatePollOnDomainForFk491C8241A2624E1C24B22F31830Patch = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** An object where the defined keys will be set on the `poll` being updated. */
export type UpdatePollOnPollForFk92Fe09641A13814B79Fec585F8EPatch = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** An object where the defined keys will be set on the `poll` being updated. */
export type UpdatePollOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0APatch = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** An object where the defined keys will be set on the `poll` being updated. */
export type UpdatePollOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3Patch = {
  activeFrom?: InputMaybe<Scalars['Datetime']>;
  activeTo?: InputMaybe<Scalars['Datetime']>;
  assetToImageId?: InputMaybe<Fk92Fe09641A13814B79Fec585F8EInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  domainsUsingId?: InputMaybe<Fk491C8241A2624E1C24B22F31830InverseInput>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  minimumResponsesCount?: InputMaybe<Scalars['Int']>;
  purpose?: InputMaybe<Scalars['String']>;
  questionsUsingId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3InverseInput>;
  state?: InputMaybe<PollsStateEnum>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInput>;
};

/** An object where the defined keys will be set on the `question` being updated. */
export type UpdateQuestionOnOptionForFk2F023042321Cac895F71085Bdc2Patch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** An object where the defined keys will be set on the `question` being updated. */
export type UpdateQuestionOnQuestionForFk296Cab84E5Df7Fd60Cf3A96B0D3Patch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** An object where the defined keys will be set on the `question` being updated. */
export type UpdateQuestionOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2Patch = {
  content?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  help?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionsUsingId?: InputMaybe<Fk2F023042321Cac895F71085Bdc2InverseInput>;
  order?: InputMaybe<Scalars['Int']>;
  pollId?: InputMaybe<Scalars['Int']>;
  pollToPollId?: InputMaybe<Fk296Cab84E5Df7Fd60Cf3A96B0D3Input>;
  state?: InputMaybe<QuestionsStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToCreatedById?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2Input>;
};

/** An object where the defined keys will be set on the `resetPasswordToken` being updated. */
export type UpdateResetPasswordTokenOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<ResetPasswordTokenStateEnum>;
  status?: InputMaybe<ResetPasswordTokenStatusEnum>;
  token?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786Input>;
  validUntil?: InputMaybe<Scalars['Datetime']>;
};

/** An object where the defined keys will be set on the `response` being updated. */
export type UpdateResponseOnResponseForFk09F98E13892E59A2129D0F0A524Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionToOptionId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524Input>;
  state?: InputMaybe<ResponsesStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `response` being updated. */
export type UpdateResponseOnResponseForFk5B32E635D66Db78796216Bb88FfPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  optionId?: InputMaybe<Scalars['Int']>;
  optionToOptionId?: InputMaybe<Fk09F98E13892E59A2129D0F0A524Input>;
  state?: InputMaybe<ResponsesStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['String']>;
  userToCreatedById?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnAssetForFk3B4041F72C74134Fd253C373Ce7Patch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnDomainForFkCac37E9D10297530Cdef577Ce3APatch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnGroupForFkEa1D696765Abe34B320C71BffbePatch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnGroupMembershipForFk0E57A259364Bda6568F0353B559Patch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnOptionForFk981A9Ac4A18289D79488263Ed2APatch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnPollForFkCf6219Fdbf85890Ef3Dd2Cd9B0APatch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnQuestionForFkC9F18Abddaea39Caf78B19Bd7A2Patch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnResetPasswordTokenForFk3Da9Fdab00F2Fd15Fd801D70786Patch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnResponseForFk5B32E635D66Db78796216Bb88FfPatch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3Patch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `user` being updated. */
export type UpdateUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486Patch = {
  assetsUsingId?: InputMaybe<Fk3B4041F72C74134Fd253C373Ce7InverseInput>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  domainsUsingId?: InputMaybe<FkCac37E9D10297530Cdef577Ce3AInverseInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  groupMembershipsUsingId?: InputMaybe<Fk0E57A259364Bda6568F0353B559InverseInput>;
  groupsUsingId?: InputMaybe<FkEa1D696765Abe34B320C71BffbeInverseInput>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  optionsUsingId?: InputMaybe<Fk981A9Ac4A18289D79488263Ed2AInverseInput>;
  password?: InputMaybe<Scalars['String']>;
  pollsUsingId?: InputMaybe<FkCf6219Fdbf85890Ef3Dd2Cd9B0AInverseInput>;
  questionsUsingId?: InputMaybe<FkC9F18Abddaea39Caf78B19Bd7A2InverseInput>;
  resetPasswordTokensUsingId?: InputMaybe<Fk3Da9Fdab00F2Fd15Fd801D70786InverseInput>;
  responsesUsingId?: InputMaybe<Fk5B32E635D66Db78796216Bb88FfInverseInput>;
  state?: InputMaybe<UsersStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userProfilesUsingId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3InverseInput>;
  userRoleUsersUsingId?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486InverseInput>;
};

/** An object where the defined keys will be set on the `userProfile` being updated. */
export type UpdateUserProfileOnUserProfileForFkC9C0Be6396A82465Df1Cd0Ac2D3Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  profileId?: InputMaybe<Scalars['String']>;
  profileSecret?: InputMaybe<Scalars['String']>;
  profileType?: InputMaybe<UserProfileProfiletypeEnum>;
  state?: InputMaybe<UserProfileStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userToUserId?: InputMaybe<FkC9C0Be6396A82465Df1Cd0Ac2D3Input>;
};

/** An object where the defined keys will be set on the `userRole` being updated. */
export type UpdateUserRoleOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3Patch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<UserRoleStateEnum>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userRoleUsersUsingId?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3InverseInput>;
  value?: InputMaybe<Scalars['String']>;
};

/** An object where the defined keys will be set on the `userRoleUser` being updated. */
export type UpdateUserRoleUserOnUserRoleUserForFk3B1Beb6B07301C7525D24Bde7F3Patch = {
  user?: InputMaybe<Scalars['Int']>;
  userRoleToUserRole?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3Input>;
  userToUser?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486Input>;
};

/** An object where the defined keys will be set on the `userRoleUser` being updated. */
export type UpdateUserRoleUserOnUserRoleUserForFkFcc63Bfa5Dd9E061Bb4115Db486Patch = {
  userRole?: InputMaybe<Scalars['Int']>;
  userRoleToUserRole?: InputMaybe<Fk3B1Beb6B07301C7525D24Bde7F3Input>;
  userToUser?: InputMaybe<FkFcc63Bfa5Dd9E061Bb4115Db486Input>;
};

export type CreateOptionResponseMutationVariables = Exact<{
  optionId: Scalars['Int'];
  value?: InputMaybe<Scalars['String']>;
}>;


export type CreateOptionResponseMutation = { __typename?: 'Mutation', createResponse?: { __typename?: 'CreateResponsePayload', response?: { __typename?: 'Response', id: number } | null | undefined } | null | undefined };

export type GetPollQueryVariables = Exact<{
  pollId: Scalars['Int'];
}>;


export type GetPollQuery = { __typename?: 'Query', getPollByClient?: { __typename?: 'Poll', id: number, title: string, minimumResponsesCount?: number | null | undefined, currentResponsesCount?: number | null | undefined, purpose?: string | null | undefined, imageUrl?: string | null | undefined, activeFrom?: any | null | undefined, activeTo?: any | null | undefined, questions: { __typename?: 'QuestionsConnection', nodes: Array<{ __typename?: 'Question', id: number, order?: number | null | undefined, content: string, options: { __typename?: 'OptionsConnection', nodes: Array<{ __typename?: 'Option', id: number, order?: number | null | undefined, content?: string | null | undefined } | null | undefined> } } | null | undefined> } } | null | undefined };

export type GetPollResultsQueryVariables = Exact<{
  pollId: Scalars['Int'];
}>;


export type GetPollResultsQuery = { __typename?: 'Query', poll?: { __typename?: 'Poll', id: number, title: string, imageUrl?: string | null | undefined, minimumResponsesCount?: number | null | undefined, currentResponsesCount?: number | null | undefined, activeFrom?: any | null | undefined, activeTo?: any | null | undefined, questions: { __typename?: 'QuestionsConnection', nodes: Array<{ __typename?: 'Question', id: number, content: string, options: { __typename?: 'OptionsConnection', nodes: Array<{ __typename?: 'Option', id: number, content?: string | null | undefined, responses: { __typename?: 'ResponsesConnection', totalCount: number, nodes: Array<{ __typename?: 'Response', id: number } | null | undefined> } } | null | undefined> } } | null | undefined> } } | null | undefined };

export type PollResponsesSubscriptionVariables = Exact<{
  pollId: Scalars['Int'];
}>;


export type PollResponsesSubscription = { __typename?: 'Subscription', newResponseAdded?: { __typename?: 'PollResponsesSubscriptionPayload', poll?: { __typename?: 'Poll', id: number, title: string, imageUrl?: string | null | undefined, minimumResponsesCount?: number | null | undefined, currentResponsesCount?: number | null | undefined, activeFrom?: any | null | undefined, activeTo?: any | null | undefined, questions: { __typename?: 'QuestionsConnection', nodes: Array<{ __typename?: 'Question', id: number, content: string, options: { __typename?: 'OptionsConnection', nodes: Array<{ __typename?: 'Option', id: number, content?: string | null | undefined, responses: { __typename?: 'ResponsesConnection', totalCount: number, nodes: Array<{ __typename?: 'Response', id: number } | null | undefined> } } | null | undefined> } } | null | undefined> } } | null | undefined } | null | undefined };


export const CreateOptionResponseDocument = gql`
    mutation CreateOptionResponse($optionId: Int!, $value: String) {
  createResponse(
    input: {response: {optionId: $optionId, value: $value, userId: "some user"}}
  ) {
    response {
      id
    }
  }
}
    `;
export function useCreateOptionResponseMutation(baseOptions?: Apollo.MutationHookOptions<CreateOptionResponseMutation, CreateOptionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOptionResponseMutation, CreateOptionResponseMutationVariables>(CreateOptionResponseDocument, options);
      }
export type CreateOptionResponseMutationHookResult = ReturnType<typeof useCreateOptionResponseMutation>;
export type CreateOptionResponseMutationResult = Apollo.MutationResult<CreateOptionResponseMutation>;
export type CreateOptionResponseMutationOptions = Apollo.BaseMutationOptions<CreateOptionResponseMutation, CreateOptionResponseMutationVariables>;
export const GetPollDocument = gql`
    query GetPoll($pollId: Int!) {
  getPollByClient(id: $pollId) {
    id
    title
    minimumResponsesCount
    currentResponsesCount
    purpose
    imageUrl
    activeFrom
    activeTo
    questions {
      nodes {
        id
        order
        content
        options(orderBy: ORDER_ASC) {
          nodes {
            id
            order
            content
          }
        }
      }
    }
  }
}
    `;
export function useGetPollQuery(baseOptions: Apollo.QueryHookOptions<GetPollQuery, GetPollQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPollQuery, GetPollQueryVariables>(GetPollDocument, options);
      }
export function useGetPollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPollQuery, GetPollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPollQuery, GetPollQueryVariables>(GetPollDocument, options);
        }
export type GetPollQueryHookResult = ReturnType<typeof useGetPollQuery>;
export type GetPollLazyQueryHookResult = ReturnType<typeof useGetPollLazyQuery>;
export type GetPollQueryResult = Apollo.QueryResult<GetPollQuery, GetPollQueryVariables>;
export const GetPollResultsDocument = gql`
    query GetPollResults($pollId: Int!) {
  poll(id: $pollId) {
    id
    title
    imageUrl
    minimumResponsesCount
    currentResponsesCount
    activeFrom
    activeTo
    questions {
      nodes {
        id
        content
        options(orderBy: ORDER_ASC) {
          nodes {
            id
            content
            responses(condition: {value: "true"}) {
              totalCount
              nodes {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function useGetPollResultsQuery(baseOptions: Apollo.QueryHookOptions<GetPollResultsQuery, GetPollResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPollResultsQuery, GetPollResultsQueryVariables>(GetPollResultsDocument, options);
      }
export function useGetPollResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPollResultsQuery, GetPollResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPollResultsQuery, GetPollResultsQueryVariables>(GetPollResultsDocument, options);
        }
export type GetPollResultsQueryHookResult = ReturnType<typeof useGetPollResultsQuery>;
export type GetPollResultsLazyQueryHookResult = ReturnType<typeof useGetPollResultsLazyQuery>;
export type GetPollResultsQueryResult = Apollo.QueryResult<GetPollResultsQuery, GetPollResultsQueryVariables>;
export const PollResponsesDocument = gql`
    subscription PollResponses($pollId: Int!) {
  newResponseAdded(id: $pollId) {
    poll {
      id
      title
      imageUrl
      minimumResponsesCount
      currentResponsesCount
      activeFrom
      activeTo
      questions {
        nodes {
          id
          content
          options {
            nodes {
              id
              content
              responses(condition: {value: "true"}) {
                totalCount
                nodes {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export function usePollResponsesSubscription(baseOptions: Apollo.SubscriptionHookOptions<PollResponsesSubscription, PollResponsesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PollResponsesSubscription, PollResponsesSubscriptionVariables>(PollResponsesDocument, options);
      }
export type PollResponsesSubscriptionHookResult = ReturnType<typeof usePollResponsesSubscription>;
export type PollResponsesSubscriptionResult = Apollo.SubscriptionResult<PollResponsesSubscription>;